{
  "id": "minnesota",
  "name": "Minnesota",
  "viewBox": {
    "x": 0,
    "y": 0,
    "width": 1000,
    "height": 1137.9
  },
  "backdropColor": {
    "light": "#cfd3a6",
    "dark": "#2a3220",
    "topBar": true
  },
  "gameLayout": {
    "topBarOverlap": 0.65
  },
  "edgeConfig": {
    "internalBorderWidth": 2.5,
    "regionBorderWidth": 10.1,
    "bridgeStrokeWidth": 0
  },
  "decorations": [
    {
      "id": "lake-superior",
      "shape": "M 673.17 500.56 L 672.6 498.87 L 673.27 498.33 L 672.72 496.92 L 673.01 495.32 L 674.35 492.52 L 675.92 491.77 L 684.85 483.54 L 686.69 483.14 L 690.15 480.72 L 698.8 472.4 L 705.47 467.79 L 707.26 465.96 L 708.13 465.4 L 709.19 465.63 L 710.15 465.7 L 710.93 465.23 L 711.78 464.22 L 712.13 464.05 L 712.65 463.58 L 714.12 462.31 L 717.25 457.94 L 721.09 454.11 L 724.4 449.66 L 727.79 447.88 L 728.47 447.32 L 729.27 447.39 L 730.18 445.24 L 731.57 444.92 L 732.11 445.01 L 733.31 443.9 L 732.74 442.59 L 733.59 441.15 L 738.39 436.92 L 740.57 433.21 L 743.7 431.96 L 744.64 430.77 L 747.82 428.65 L 750.38 425.73 L 753.43 424.49 L 756.16 421.2 L 760.34 414.07 L 765.68 409.91 L 767.12 408.1 L 768.86 404.57 L 772.78 400.29 L 775.96 397.97 L 776.49 397.33 L 776.29 396.8 L 776.52 395.73 L 777.46 394.72 L 779.91 391.27 L 783.85 387.77 L 786.02 383.79 L 788.82 380.6 L 790.37 376.37 L 796.55 368.35 L 798.06 366.54 L 801.01 364.49 L 802.92 361.06 L 808.14 356.71 L 809.88 355.68 L 811.73 353.23 L 822.15 343.12 L 841.64 325.35 L 848.93 319.97 L 852.93 318.51 L 857.2 314.65 L 860.42 313.4 L 868.42 308.25 L 868.82 307.34 L 872.77 304.36 L 877.8 302.43 L 881.3 301.7 L 883.51 299.32 L 884.64 299.11 L 885.7 299.25 L 892.47 296.9 L 895.01 296.83 L 896.23 296.26 L 897.9 293.8 L 898.86 293.31 L 906.34 291.14 L 911.11 289.1 L 914.85 288.37 L 918.19 285.87 L 928.41 281.53 L 930.53 281.55 L 932.31 279.88 L 933.61 279.13 L 937.6 277.84 L 940.92 274.97 L 944.14 273.98 L 948.11 269.04 L 956.79 266.18 L 963.94 262.48 L 966.92 259.54 L 969.16 258.21 L 973.9 252.98 L 977.08 250.99 L 977.06 250.45 L 976.14 249.6 L 976.47 248.78 L 978.02 247.93 L 979.85 247.51 L 980.79 249.27 L 982.11 249.32 L 981.26 244.88 L 981.92 243.79 L 983.03 242.87 L 984.93 242.27 L 985.68 243.67 L 986.74 243.91 L 991.32 241.61 L 999.39 239.12 L 999.9 238.39 L 996.24 239.32 L 994.22 239.19 L 992.31 239.7 L 993.51 239.12 L 1001.48 237.1 L 950.3 380.53 L 857.53 384.33 L 793.8 432.67 L 754.51 461.52 L 684.03 508.91 L 682.32 508.18 L 674.94 501.04 Z M 683.38 507.2 L 683.56 506.67 L 678.72 501.03 L 677.89 499.44 L 675.33 496.31 L 674.46 496.15 L 675.33 498.97 L 682.15 507.13 L 683.05 507.55 Z",
      "fill": "#3a6ea5"
    }
  ],
  "regions": [
    {
      "id": "arrowhead",
      "name": "Arrowhead",
      "bonus": 4,
      "territoryIds": [
        "cook",
        "lake",
        "saint-louis",
        "carlton",
        "itasca",
        "koochiching",
        "lake-of-the-woods"
      ],
      "color": "#1B5E20",
      "shape": "M 356.05 133.44 L 350.78 132.2 L 346.58 132.03 L 345.69 131.87 L 344.89 131.26 L 344.27 130.66 L 342.93 129.35 L 339.06 128.81 L 337.29 127.16 L 333.39 124.91 L 331.89 124.32 L 331.42 123.26 L 329.81 121.14 L 325.35 117.13 L 324.88 116.07 L 324.31 113.65 L 324.43 111.06 L 323.7 109.2 L 323.49 107.95 L 323.65 107.51 L 324.5 106.24 L 325.94 104.41 L 325.32 99.68 L 327.02 97.77 L 326.12 96.36 L 317.21 55.9 L 314.42 51.84 L 311.62 39.82 L 310.07 28.56 L 307.2 16.43 L 308.51 11.92 L 304.03 11.29 L 301.13 10.2 L 295.45 5.74 L 290.34 2.8 L 286.34 3.25 L 282.63 5.85 L 278.19 6.3 L 270.1 3.24 L 266.03 0.0 L 266.06 74.66 L 249.11 74.66 L 248.09 75.47 L 247.22 75.4 L 245.56 75.89 L 244.87 76.62 L 244.4 78.5 L 244.27 81.29 L 244.55 82.71 L 245.46 83.86 L 246.15 84.02 L 246.61 84.82 L 245.79 85.34 L 244.61 85.78 L 244.24 87.31 L 247.55 92.93 L 248.78 94.51 L 252.45 97.05 L 255.71 97.87 L 265.19 95.8 L 270.05 93.82 L 272.36 92.06 L 273.48 90.51 L 273.75 129.61 L 241.91 129.91 L 241.79 163.25 L 258.42 163.35 L 258.67 196.77 L 284.23 196.49 L 359.37 195.72 L 359.89 195.81 L 361.51 264.04 L 362.04 264.11 L 362.33 297.18 L 362.82 322.64 L 362.68 344.55 L 363.08 346.15 L 363.29 356.12 L 363.62 374.7 L 364.68 375.03 L 364.89 376.1 L 365.08 376.81 L 367.03 377.84 L 367.92 377.91 L 367.99 377.28 L 369.05 377.61 L 370.13 378.38 L 372.77 378.67 L 374.01 379.37 L 375.35 380.22 L 376.04 380.12 L 403.37 367.57 L 404.41 367.46 L 406.99 368.65 L 410.76 376.11 L 412.94 378.65 L 414.1 379.79 L 413.96 381.39 L 413.46 382.38 L 413.46 385.84 L 414.71 390.89 L 416.42 392.8 L 420.94 394.39 L 422.91 395.59 L 425.34 398.28 L 425.92 400.06 L 428.15 401.33 L 429.66 402.55 L 430.88 401.89 L 432.17 400.53 L 432.24 399.82 L 433.49 397.12 L 435.42 396.98 L 440.26 400.51 L 444.12 400.51 L 446.49 400.01 L 448.7 400.32 L 449.06 400.67 L 448.91 401.73 L 447.62 403.02 L 447.53 403.45 L 447.95 406.12 L 447.24 405.59 L 446.63 406.06 L 446.96 408.9 L 446.98 409.42 L 445.83 409.28 L 445.32 409.82 L 444.23 411.81 L 445.2 416.23 L 446.12 417.81 L 446.82 417.88 L 448.52 418.91 L 449.43 453.55 L 474.31 452.77 L 529.41 452.32 L 544.18 451.95 L 545.45 502.11 L 546.39 535.62 L 547.37 535.69 L 548.48 569.37 L 650.58 566.11 L 649.26 532.07 L 648.81 518.6 L 648.77 517.72 L 651.14 520.4 L 652.03 520.2 L 653.61 520.34 L 659.02 520.64 L 660.0 519.79 L 660.08 519.04 L 660.14 517.05 L 663.15 513.92 L 663.27 512.7 L 662.08 511.9 L 660.52 511.82 L 659.93 511.33 L 659.86 510.15 L 660.54 509.08 L 662.76 507.22 L 666.77 507.41 L 667.62 504.25 L 667.97 503.31 L 670.45 501.36 L 673.05 500.57 L 673.17 500.56 L 672.6 498.87 L 673.03 498.87 L 673.08 497.62 L 672.61 496.4 L 672.86 495.86 L 673.17 494.41 L 674.35 492.52 L 675.92 491.77 L 684.85 483.54 L 686.69 483.14 L 690.15 480.72 L 698.8 472.4 L 706.32 467.04 L 707.68 465.49 L 708.57 465.56 L 709.19 465.63 L 710.15 465.7 L 710.93 465.23 L 711.78 464.22 L 712.13 464.05 L 714.12 462.31 L 717.25 457.94 L 721.09 454.11 L 724.4 449.66 L 727.1 448.07 L 728.47 447.32 L 729.01 447.48 L 729.78 446.58 L 730.18 445.24 L 731.05 445.11 L 732.55 444.73 L 733.21 443.63 L 732.74 442.59 L 733.07 441.86 L 738.39 436.92 L 740.57 433.21 L 743.7 431.96 L 744.64 430.77 L 747.82 428.65 L 750.38 425.73 L 753.43 424.49 L 756.16 421.2 L 760.34 414.07 L 765.68 409.91 L 767.12 408.1 L 768.86 404.57 L 772.78 400.29 L 776.49 397.33 L 776.28 396.27 L 776.96 395.36 L 779.91 391.27 L 783.85 387.77 L 786.02 383.79 L 788.82 380.6 L 790.37 376.37 L 796.55 368.35 L 798.06 366.54 L 801.01 364.49 L 802.92 361.06 L 807.03 357.37 L 808.14 356.71 L 809.88 355.68 L 811.73 353.23 L 822.15 343.12 L 841.64 325.35 L 848.93 319.97 L 852.93 318.51 L 856.61 315.29 L 857.55 314.2 L 860.42 313.4 L 863.27 311.88 L 868.42 308.25 L 868.82 307.34 L 872.77 304.36 L 877.8 302.43 L 881.3 301.7 L 882.9 299.7 L 883.86 299.13 L 885.7 299.25 L 891.17 297.21 L 895.01 296.83 L 896.23 296.26 L 897.9 293.8 L 898.86 293.31 L 906.34 291.14 L 911.11 289.1 L 914.85 288.37 L 918.19 285.87 L 928.41 281.53 L 930.53 281.55 L 931.47 280.89 L 932.65 279.62 L 937.6 277.84 L 940.92 274.97 L 944.14 273.98 L 948.11 269.04 L 956.79 266.18 L 963.94 262.48 L 966.92 259.54 L 969.16 258.21 L 973.9 252.98 L 977.08 250.99 L 976.14 249.6 L 976.47 248.78 L 979.85 247.51 L 980.42 248.92 L 982.11 249.32 L 981.47 245.86 L 981.33 244.71 L 981.92 243.79 L 983.8 242.4 L 984.67 242.27 L 985.12 242.34 L 985.59 243.49 L 986.74 243.91 L 991.32 241.61 L 999.39 239.12 L 999.98 238.48 L 999.2 238.41 L 998.33 238.98 L 992.31 239.7 L 991.02 240.46 L 989.63 241.04 L 988.64 240.36 L 987.12 239.42 L 985.96 238.93 L 985.66 237.96 L 985.21 237.44 L 982.55 238.95 L 981.08 239.89 L 979.74 239.32 L 979.03 238.71 L 977.1 238.95 L 973.97 239.4 L 972.1 239.11 L 971.63 238.24 L 970.56 237.45 L 969.95 237.49 L 969.15 237.24 L 968.36 237.63 L 967.75 237.37 L 964.76 237.47 L 961.82 238.72 L 960.88 239.28 L 959.99 238.95 L 958.67 238.91 L 957.43 240.92 L 957.21 242.08 L 956.42 242.38 L 952.65 244.9 L 951.6 245.11 L 948.61 244.94 L 946.58 244.12 L 945.04 243.09 L 942.94 240.39 L 941.35 240.53 L 940.24 241.02 L 939.16 240.6 L 937.09 238.71 L 935.58 238.31 L 935.37 237.33 L 934.88 233.15 L 933.96 231.75 L 932.51 230.72 L 930.65 227.48 L 923.74 225.11 L 919.17 224.98 L 916.68 223.81 L 914.22 223.88 L 910.81 224.26 L 907.87 225.34 L 904.1 225.27 L 901.5 226.33 L 897.74 226.8 L 896.37 227.48 L 895.38 226.96 L 893.6 226.32 L 889.3 228.77 L 886.59 229.03 L 884.94 229.52 L 884.05 228.93 L 882.33 227.27 L 880.92 227.24 L 878.06 228.3 L 876.29 228.0 L 873.9 227.19 L 869.83 229.0 L 863.81 229.73 L 861.18 229.71 L 860.43 228.49 L 861.08 226.59 L 861.76 225.85 L 861.48 225.24 L 857.7 225.36 L 856.43 226.56 L 853.91 227.43 L 850.64 229.4 L 845.07 230.37 L 842.65 231.52 L 838.18 232.01 L 836.63 232.51 L 835.53 231.38 L 833.46 226.98 L 832.28 225.67 L 829.79 224.23 L 830.19 223.24 L 831.76 222.56 L 832.59 221.55 L 832.52 219.15 L 831.89 218.9 L 829.63 219.32 L 828.95 217.48 L 828.74 216.14 L 827.23 215.65 L 826.97 215.39 L 826.27 215.58 L 825.79 217.11 L 825.26 217.13 L 824.92 214.38 L 823.89 204.04 L 823.52 203.61 L 822.48 203.64 L 820.93 204.67 L 819.63 204.89 L 818.72 204.28 L 817.57 203.69 L 814.14 206.56 L 806.94 208.93 L 800.99 214.55 L 799.79 215.39 L 799.53 215.39 L 798.48 215.6 L 796.05 216.38 L 795.19 217.13 L 794.69 217.86 L 792.25 218.55 L 791.83 219.09 L 791.07 220.02 L 786.68 222.73 L 785.43 224.82 L 783.39 226.84 L 779.97 229.88 L 779.43 229.47 L 776.59 233.73 L 772.57 237.51 L 770.43 238.91 L 769.02 239.04 L 765.91 240.46 L 759.95 240.81 L 757.26 241.53 L 756.32 241.91 L 754.09 244.21 L 752.87 244.41 L 750.96 244.64 L 749.41 245.75 L 747.96 244.64 L 746.57 242.1 L 741.42 242.6 L 736.39 244.8 L 731.47 247.25 L 730.58 246.66 L 730.47 243.27 L 730.93 237.8 L 731.36 237.52 L 732.35 235.89 L 731.81 235.38 L 724.16 236.93 L 721.79 237.52 L 721.08 236.84 L 719.7 234.91 L 719.01 234.76 L 717.98 235.85 L 716.22 235.64 L 715.49 234.86 L 715.89 233.68 L 715.72 233.42 L 713.4 235.17 L 712.17 235.12 L 712.22 233.78 L 713.8 230.98 L 713.75 229.27 L 712.67 228.06 L 712.55 227.08 L 712.85 225.38 L 712.45 223.43 L 710.36 224.19 L 710.41 223.13 L 711.68 221.39 L 711.52 218.99 L 709.64 217.88 L 708.51 217.91 L 707.05 218.85 L 706.32 218.15 L 702.91 218.07 L 702.07 219.42 L 701.64 219.44 L 700.72 218.03 L 700.18 217.79 L 697.69 216.78 L 696.82 216.54 L 694.47 217.32 L 692.97 217.18 L 691.56 216.69 L 691.18 215.8 L 687.94 212.95 L 687.84 212.24 L 683.72 212.34 L 682.17 213.28 L 680.25 213.61 L 679.35 212.83 L 680.01 211.38 L 679.43 209.78 L 678.2 209.28 L 677.43 209.94 L 677.03 211.19 L 675.94 209.97 L 674.72 207.24 L 673.06 207.28 L 671.69 202.32 L 672.56 195.77 L 668.33 195.1 L 668.04 194.12 L 666.59 192.73 L 666.49 192.1 L 666.26 190.33 L 665.53 189.01 L 663.6 188.97 L 662.07 190.35 L 653.73 190.22 L 653.7 188.61 L 652.29 188.47 L 649.71 190.59 L 649.57 191.58 L 645.46 191.88 L 638.78 191.51 L 636.47 193.09 L 635.72 194.28 L 634.99 196.52 L 633.81 198.26 L 634.1 199.59 L 635.04 201.45 L 634.87 204.75 L 635.72 207.31 L 637.27 209.42 L 638.35 210.38 L 639.01 211.87 L 638.68 212.86 L 637.02 213.18 L 633.96 213.52 L 631.47 215.2 L 628.52 216.0 L 626.2 217.84 L 624.91 215.91 L 623.5 212.55 L 622.88 211.59 L 618.3 201.8 L 616.99 201.66 L 611.83 192.59 L 611.17 190.55 L 611.11 188.87 L 613.17 183.44 L 613.1 181.21 L 611.06 180.37 L 606.71 174.77 L 602.76 174.7 L 596.16 176.56 L 587.43 177.69 L 583.1 176.2 L 579.75 172.18 L 581.32 168.38 L 582.47 166.02 L 583.7 166.0 L 585.79 165.93 L 590.75 164.56 L 590.75 160.99 L 589.5 156.9 L 585.36 156.2 L 579.2 157.72 L 576.92 157.68 L 565.75 152.25 L 553.63 147.55 L 550.43 145.67 L 548.74 145.26 L 548.55 144.37 L 548.57 141.34 L 547.07 141.38 L 544.22 142.7 L 530.38 142.42 L 523.49 143.13 L 519.3 143.59 L 518.41 142.63 L 517.32 141.32 L 515.37 140.38 L 512.3 139.91 L 508.98 140.09 L 497.42 143.69 L 495.93 146.32 L 494.73 147.41 L 492.71 147.66 L 491.32 147.5 L 489.91 147.27 L 486.46 149.68 L 482.65 150.76 L 482.32 151.75 L 483.64 155.82 L 483.52 157.98 L 482.6 159.42 L 479.03 160.41 L 476.26 161.82 L 475.48 162.1 L 473.65 162.68 L 472.19 163.25 L 470.0 163.41 L 468.0 163.53 L 466.24 163.3 L 465.46 163.69 L 464.17 164.61 L 463.09 163.82 L 461.85 162.97 L 460.74 164.15 L 459.97 165.34 L 456.32 166.05 L 449.39 165.6 L 442.66 166.19 L 440.92 166.07 L 439.23 165.03 L 438.07 164.26 L 438.29 162.47 L 438.71 161.48 L 438.57 159.68 L 439.63 156.62 L 439.44 155.65 L 436.62 147.66 L 434.72 144.86 L 425.85 143.99 L 420.61 144.19 L 414.19 142.84 L 410.26 143.01 L 405.96 142.21 L 394.66 142.12 L 388.85 141.01 L 386.59 141.5 L 382.2 140.35 L 381.28 138.59 L 381.89 134.9 L 380.17 132.0 L 375.49 129.96 L 371.83 131.11 L 368.77 131.09 L 367.29 130.95 L 364.63 129.75 L 360.96 129.84 L 359.41 130.59 L 358.55 131.51 L 357.35 133.06 L 356.05 133.44 Z",
      "bonusAnchor": {
        "x": 695.59,
        "y": 338.75
      }
    },
    {
      "id": "far-north",
      "name": "Far North",
      "bonus": 3,
      "territoryIds": [
        "kittson",
        "roseau",
        "marshall",
        "pennington",
        "red-lake",
        "beltrami"
      ],
      "color": "#EC407A",
      "shape": "M 0.66 72.93 L 1.5 73.72 L 0.35 75.16 L 0.14 78.83 L 1.06 79.51 L 0.97 81.22 L 0.64 82.17 L 1.62 85.18 L 2.73 85.62 L 2.58 87.12 L 2.73 87.99 L 3.15 89.74 L 3.72 91.14 L 5.64 92.98 L 5.03 93.52 L 5.17 95.66 L 7.26 96.53 L 6.2 98.06 L 6.33 98.69 L 7.2 98.95 L 7.76 101.18 L 7.41 101.84 L 7.0 102.43 L 7.62 102.95 L 7.73 103.93 L 6.68 104.67 L 6.39 105.04 L 7.13 106.75 L 6.28 107.56 L 5.78 108.36 L 9.1 109.06 L 9.68 109.58 L 7.15 110.96 L 7.13 111.2 L 9.0 110.8 L 7.94 112.44 L 8.11 112.7 L 9.34 112.85 L 9.61 114.12 L 10.95 115.13 L 9.85 115.78 L 10.18 116.7 L 10.93 117.67 L 10.55 118.96 L 9.99 119.76 L 10.44 120.46 L 12.13 121.33 L 11.59 123.19 L 11.45 123.59 L 12.84 124.69 L 12.02 125.31 L 13.64 127.56 L 15.19 129.3 L 14.3 129.84 L 14.11 130.27 L 15.4 132.43 L 17.35 133.56 L 16.58 134.34 L 16.18 135.41 L 16.29 136.57 L 15.64 137.25 L 15.33 137.86 L 16.36 138.45 L 15.85 139.69 L 14.5 141.38 L 14.91 143.92 L 13.94 144.11 L 13.17 143.46 L 12.25 143.93 L 12.27 144.73 L 13.3 146.16 L 12.74 146.42 L 12.02 145.71 L 11.76 145.81 L 12.22 147.33 L 10.48 147.08 L 9.52 147.81 L 10.01 148.37 L 11.14 148.44 L 11.29 148.91 L 9.62 150.51 L 9.29 150.69 L 10.18 151.43 L 10.34 153.24 L 8.58 153.31 L 8.21 153.64 L 9.8 155.14 L 9.76 155.8 L 6.72 156.88 L 6.44 157.12 L 6.84 157.87 L 9.68 157.91 L 10.74 159.06 L 7.8 159.06 L 7.26 159.82 L 7.4 160.2 L 7.5 160.38 L 8.06 161.06 L 10.62 162.71 L 9.05 163.46 L 9.07 164.8 L 9.61 165.51 L 11.76 165.2 L 12.36 165.62 L 11.56 166.73 L 9.38 167.04 L 9.31 168.73 L 11.69 171.12 L 11.24 171.39 L 10.22 170.85 L 9.94 171.12 L 10.04 172.28 L 9.12 172.84 L 7.97 173.24 L 8.28 173.88 L 10.62 173.53 L 12.11 174.13 L 11.75 174.75 L 9.83 174.54 L 9.59 175.33 L 9.85 175.87 L 11.56 176.67 L 12.08 177.43 L 11.8 178.46 L 10.49 179.73 L 9.59 180.22 L 9.41 180.88 L 9.76 181.14 L 12.2 180.37 L 12.56 181.54 L 11.64 182.84 L 10.3 182.29 L 9.87 182.74 L 12.16 184.15 L 12.39 185.07 L 11.5 185.16 L 10.68 184.53 L 9.34 184.67 L 8.68 185.0 L 8.51 185.72 L 10.74 185.63 L 11.35 187.46 L 9.54 189.09 L 8.47 189.28 L 7.36 189.75 L 8.02 191.69 L 10.68 191.91 L 10.01 192.94 L 10.04 194.02 L 8.13 194.56 L 8.13 195.69 L 9.22 196.85 L 10.32 198.23 L 10.04 198.66 L 9.87 198.94 L 11.36 200.21 L 11.0 201.67 L 10.35 202.02 L 9.83 202.47 L 11.66 202.51 L 12.55 203.22 L 12.55 203.99 L 10.86 204.25 L 10.56 204.7 L 10.16 205.71 L 11.73 205.92 L 11.64 207.43 L 12.93 208.6 L 12.27 209.0 L 10.88 208.55 L 10.11 209.97 L 11.59 209.75 L 12.2 211.4 L 11.4 213.32 L 9.8 213.75 L 9.21 213.82 L 9.14 214.34 L 10.89 214.53 L 11.73 215.21 L 11.07 215.84 L 11.42 217.42 L 9.19 218.21 L 8.72 218.71 L 10.01 219.2 L 9.31 220.24 L 9.05 220.69 L 11.8 222.43 L 9.52 222.33 L 8.54 222.77 L 8.27 223.5 L 10.82 223.29 L 11.83 224.66 L 11.94 225.46 L 11.02 225.57 L 9.9 223.9 L 10.32 225.38 L 9.4 226.16 L 9.24 226.58 L 9.52 227.64 L 9.01 228.73 L 8.18 229.85 L 8.25 230.53 L 9.43 230.89 L 9.68 231.62 L 9.64 231.83 L 91.38 233.52 L 91.01 263.23 L 93.55 263.17 L 93.57 274.14 L 93.17 296.52 L 110.28 296.92 L 110.14 313.48 L 176.96 314.44 L 177.08 297.51 L 193.84 297.35 L 193.69 280.78 L 210.81 281.06 L 210.74 263.96 L 257.13 263.97 L 253.22 270.13 L 251.08 275.67 L 250.24 281.71 L 251.29 286.81 L 253.83 290.56 L 261.05 292.7 L 261.14 331.62 L 262.44 330.78 L 263.14 381.86 L 327.56 381.82 L 330.21 381.86 L 363.69 381.46 L 363.62 374.7 L 363.08 346.15 L 362.68 344.55 L 362.82 322.64 L 362.33 297.18 L 362.04 264.11 L 361.51 264.04 L 359.89 195.81 L 359.37 195.72 L 258.67 196.77 L 258.42 163.35 L 250.02 163.35 L 241.79 163.25 L 241.91 129.91 L 273.75 129.61 L 273.48 90.51 L 272.36 92.06 L 270.05 93.82 L 265.19 95.8 L 255.71 97.87 L 252.45 97.05 L 249.25 94.7 L 248.33 94.29 L 244.67 88.44 L 244.19 86.25 L 244.61 85.78 L 246.61 84.82 L 246.15 84.02 L 244.92 83.43 L 244.55 82.71 L 244.17 80.83 L 244.87 76.62 L 246.35 75.51 L 247.22 75.4 L 248.78 75.02 L 249.11 74.66 L 163.58 74.59 L 115.69 73.91 L 106.17 73.82 L 1.51 71.82 L 0.66 72.93 Z",
      "bonusAnchor": {
        "x": 159.45,
        "y": 163.1
      }
    },
    {
      "id": "northwest",
      "name": "Northwest",
      "bonus": 4,
      "territoryIds": [
        "polk",
        "norman",
        "mahnomen",
        "clay",
        "becker",
        "clearwater",
        "hubbard"
      ],
      "color": "#9FA8DA",
      "shape": "M 8.23 233.33 L 8.51 234.77 L 9.1 235.21 L 10.89 234.37 L 11.28 234.83 L 8.61 237.12 L 8.47 238.34 L 10.88 238.55 L 11.15 239.12 L 10.15 239.59 L 10.51 241.06 L 10.93 242.26 L 11.15 245.39 L 12.55 245.46 L 13.57 247.25 L 12.9 247.93 L 13.0 248.38 L 13.8 249.16 L 13.77 250.17 L 13.49 251.67 L 16.53 255.6 L 17.19 256.37 L 17.56 262.25 L 18.31 263.26 L 17.99 263.99 L 18.01 265.16 L 18.71 266.38 L 19.51 267.26 L 19.59 268.38 L 18.71 271.37 L 18.99 273.41 L 19.37 274.83 L 19.37 276.56 L 20.15 277.16 L 21.09 277.48 L 21.53 278.37 L 22.19 279.78 L 23.68 281.53 L 23.55 282.26 L 24.26 283.73 L 23.37 283.76 L 23.11 284.49 L 23.3 285.47 L 23.06 286.18 L 23.77 287.24 L 23.08 287.69 L 23.02 288.48 L 23.65 289.85 L 23.53 290.44 L 24.1 290.88 L 25.3 291.47 L 25.37 291.92 L 26.07 293.26 L 26.56 296.1 L 27.76 297.77 L 28.09 299.2 L 27.93 299.39 L 29.03 300.43 L 28.37 301.2 L 28.45 302.62 L 27.48 302.75 L 27.46 303.65 L 29.04 304.24 L 29.2 304.9 L 29.15 305.15 L 29.98 305.22 L 31.22 306.63 L 30.75 307.5 L 30.78 307.97 L 31.85 308.92 L 31.36 309.48 L 31.43 309.85 L 32.18 309.79 L 34.07 311.38 L 33.92 312.46 L 34.87 313.52 L 33.59 313.26 L 33.59 313.81 L 34.89 314.68 L 34.77 315.82 L 34.79 318.06 L 35.97 319.54 L 35.01 320.64 L 34.77 321.26 L 35.67 321.24 L 36.56 323.28 L 36.3 323.72 L 36.18 324.27 L 37.29 325.58 L 37.75 326.55 L 38.72 327.84 L 38.89 328.85 L 40.18 329.96 L 39.78 330.71 L 40.43 334.24 L 40.69 335.25 L 40.09 336.04 L 39.8 336.91 L 40.67 338.16 L 41.24 339.31 L 41.43 340.47 L 42.44 341.33 L 43.44 341.76 L 43.7 342.56 L 43.77 343.01 L 44.27 344.34 L 43.92 344.6 L 43.73 345.16 L 44.48 346.2 L 44.06 347.54 L 43.38 348.53 L 43.75 349.85 L 42.44 350.15 L 42.18 350.9 L 44.29 350.74 L 44.27 351.21 L 42.83 351.87 L 42.83 352.19 L 44.1 352.93 L 43.3 354.22 L 44.81 355.65 L 44.11 355.81 L 42.9 355.18 L 42.62 355.42 L 43.52 356.71 L 42.43 357.37 L 41.59 358.22 L 42.04 359.41 L 42.95 360.19 L 45.07 360.42 L 43.94 361.06 L 44.98 361.98 L 43.78 362.23 L 43.78 362.98 L 44.03 363.24 L 44.15 363.93 L 42.84 364.56 L 42.51 365.05 L 43.84 365.97 L 42.18 366.53 L 41.92 367.24 L 42.48 367.45 L 43.42 366.94 L 44.01 367.36 L 42.84 368.54 L 42.81 369.17 L 42.79 369.43 L 43.47 370.51 L 42.67 371.33 L 42.58 371.64 L 43.42 372.37 L 43.07 372.65 L 43.09 374.08 L 42.84 375.14 L 42.72 375.4 L 43.58 376.46 L 42.79 376.83 L 42.64 377.0 L 43.07 377.99 L 41.94 378.55 L 41.56 378.99 L 42.57 379.75 L 43.16 380.41 L 44.6 380.27 L 44.45 381.53 L 44.45 381.79 L 45.35 383.02 L 44.45 383.46 L 44.39 383.67 L 45.42 384.64 L 45.32 386.05 L 44.34 386.07 L 44.08 386.24 L 44.5 387.01 L 43.84 387.41 L 43.68 387.67 L 45.07 387.74 L 45.28 388.28 L 43.47 388.63 L 43.38 388.89 L 43.89 390.16 L 43.89 390.61 L 45.61 391.41 L 45.4 392.12 L 44.36 392.19 L 44.74 393.52 L 45.11 394.23 L 46.05 394.56 L 45.84 395.26 L 44.86 395.66 L 44.6 396.11 L 46.17 396.65 L 45.42 398.01 L 44.64 398.23 L 44.43 399.99 L 45.45 401.35 L 44.79 402.6 L 44.31 403.73 L 44.57 405.16 L 44.78 405.98 L 44.11 407.09 L 43.77 407.52 L 45.28 408.15 L 44.88 408.76 L 44.03 408.83 L 43.77 409.11 L 44.92 409.7 L 44.51 410.78 L 44.51 410.95 L 45.51 411.89 L 45.38 412.52 L 44.45 413.01 L 44.27 413.35 L 45.96 414.66 L 44.53 414.78 L 44.38 414.94 L 45.63 416.0 L 44.15 416.75 L 43.91 417.64 L 45.23 417.36 L 45.37 419.36 L 45.28 419.58 L 46.06 421.01 L 44.85 421.26 L 44.29 422.77 L 45.04 422.33 L 45.79 422.68 L 46.12 423.47 L 45.44 424.04 L 45.44 424.27 L 46.69 424.46 L 45.8 425.78 L 45.8 426.13 L 46.78 427.1 L 46.97 428.44 L 45.77 428.72 L 46.36 429.83 L 44.95 429.85 L 44.81 429.89 L 44.72 430.23 L 44.83 430.51 L 44.9 430.62 L 45.73 431.92 L 45.85 433.87 L 45.94 434.67 L 46.72 435.39 L 45.09 435.75 L 44.65 436.12 L 44.92 436.46 L 46.45 437.49 L 46.69 438.05 L 47.32 439.07 L 47.0 439.81 L 46.92 440.07 L 46.93 441.44 L 46.41 441.84 L 45.91 442.45 L 47.14 442.9 L 46.81 444.42 L 46.12 444.8 L 45.56 445.46 L 46.48 445.93 L 46.69 447.62 L 46.13 447.9 L 45.92 448.32 L 46.66 449.69 L 46.03 450.21 L 45.79 450.72 L 46.74 451.08 L 46.69 452.34 L 47.86 452.18 L 47.23 453.03 L 46.01 453.31 L 45.82 453.48 L 46.9 454.48 L 45.54 455.42 L 44.15 458.15 L 44.6 458.95 L 45.96 458.91 L 46.46 460.25 L 46.22 460.97 L 46.39 462.88 L 46.52 463.61 L 46.34 465.96 L 47.28 466.61 L 47.72 466.26 L 48.24 466.78 L 49.25 466.03 L 49.39 466.76 L 48.69 468.1 L 48.71 468.29 L 49.16 468.99 L 48.69 469.74 L 48.66 470.33 L 50.07 470.4 L 50.17 471.51 L 50.03 473.6 L 51.46 474.28 L 53.29 472.85 L 54.33 472.63 L 54.43 473.25 L 53.69 473.84 L 54.94 474.63 L 53.84 475.22 L 54.82 476.32 L 53.88 476.63 L 53.7 476.91 L 53.11 478.25 L 52.61 478.6 L 52.4 479.12 L 52.08 479.87 L 52.83 480.91 L 52.36 481.28 L 52.19 481.64 L 53.2 483.31 L 52.75 483.76 L 51.79 483.42 L 51.53 483.69 L 51.63 484.58 L 51.11 484.95 L 50.87 486.37 L 51.68 488.04 L 50.81 488.24 L 50.76 488.36 L 51.79 488.93 L 51.18 489.89 L 51.89 490.85 L 51.13 491.16 L 50.41 490.74 L 50.55 492.01 L 49.82 491.89 L 49.54 492.12 L 50.88 493.61 L 49.72 494.0 L 48.41 495.89 L 48.88 497.02 L 48.36 497.65 L 48.41 497.95 L 48.83 499.08 L 49.09 500.59 L 50.19 501.55 L 49.32 502.59 L 49.21 503.08 L 50.45 503.15 L 49.75 503.79 L 50.83 505.01 L 50.12 505.43 L 50.85 506.25 L 50.31 507.0 L 50.17 508.13 L 50.73 509.71 L 50.41 511.59 L 50.24 511.94 L 50.66 512.51 L 50.22 513.03 L 49.94 513.3 L 50.62 513.8 L 49.75 514.44 L 49.7 514.62 L 50.14 515.94 L 49.54 517.19 L 49.28 517.37 L 50.0 517.98 L 49.25 519.39 L 49.3 519.72 L 49.74 520.85 L 48.95 521.6 L 48.57 521.93 L 49.11 522.61 L 48.4 522.71 L 48.22 522.81 L 49.02 523.63 L 48.41 523.96 L 48.17 524.94 L 47.91 526.07 L 47.66 526.54 L 48.83 527.67 L 48.5 528.57 L 48.41 528.75 L 49.35 529.37 L 48.53 530.87 L 48.29 531.43 L 48.76 531.45 L 49.81 531.41 L 49.98 531.6 L 116.86 532.49 L 131.49 532.65 L 131.44 515.61 L 151.63 515.94 L 152.5 515.57 L 153.84 515.99 L 266.06 515.98 L 265.8 498.94 L 304.21 498.92 L 316.09 498.92 L 332.83 499.1 L 333.08 465.61 L 331.93 465.63 L 331.46 398.89 L 330.4 398.84 L 330.21 381.86 L 327.56 381.82 L 263.14 381.86 L 262.44 330.78 L 261.14 331.62 L 261.05 292.7 L 253.83 290.56 L 251.29 286.81 L 250.24 281.71 L 251.08 275.67 L 253.22 270.13 L 257.13 263.97 L 210.74 263.96 L 210.81 281.06 L 193.69 280.78 L 193.84 297.35 L 177.08 297.51 L 176.96 314.44 L 110.14 313.48 L 110.28 296.92 L 93.17 296.52 L 93.57 274.14 L 93.55 263.17 L 91.01 263.23 L 91.38 233.52 L 9.64 231.83 L 8.7 232.21 L 8.23 233.33 Z",
      "bonusAnchor": {
        "x": 145.3,
        "y": 401.87
      }
    },
    {
      "id": "north-central",
      "name": "North Central",
      "bonus": 3,
      "territoryIds": [
        "cass",
        "crow-wing",
        "aitkin",
        "wadena",
        "otter-tail"
      ],
      "color": "#7A0000",
      "shape": "M 331.46 398.89 L 331.93 465.63 L 333.08 465.61 L 332.83 499.1 L 316.09 498.92 L 304.21 498.92 L 265.8 498.94 L 266.06 515.98 L 153.84 515.99 L 152.5 515.57 L 151.63 515.94 L 131.44 515.61 L 131.49 532.65 L 116.86 532.49 L 116.32 599.35 L 118.42 599.31 L 117.9 633.42 L 142.19 633.94 L 184.83 634.28 L 268.76 634.19 L 268.52 600.43 L 267.19 600.38 L 267.19 583.36 L 323.8 583.22 L 324.01 584.45 L 324.66 585.78 L 327.67 586.59 L 329.98 586.89 L 331.29 586.33 L 331.89 585.79 L 333.48 586.19 L 333.76 586.72 L 334.4 587.41 L 334.84 587.67 L 335.72 587.83 L 337.41 587.88 L 337.88 589.2 L 338.63 591.4 L 339.53 592.27 L 340.58 592.25 L 342.08 591.59 L 347.26 594.93 L 349.49 596.04 L 350.45 595.66 L 350.36 595.05 L 352.1 594.56 L 354.29 593.62 L 357.28 593.66 L 359.81 591.73 L 364.0 590.13 L 365.34 590.54 L 366.14 591.33 L 367.4 591.74 L 368.47 592.79 L 369.12 594.09 L 369.41 595.07 L 370.84 596.27 L 373.05 596.58 L 374.65 596.9 L 375.84 598.2 L 375.96 599.61 L 376.15 600.41 L 376.32 600.58 L 377.23 601.63 L 376.44 602.45 L 375.84 602.55 L 375.07 603.54 L 375.07 604.07 L 375.0 604.69 L 373.45 606.41 L 373.12 606.95 L 372.08 607.86 L 370.58 608.42 L 370.42 608.87 L 370.35 609.49 L 370.27 609.84 L 370.01 609.95 L 369.74 610.38 L 369.61 611.72 L 369.55 613.76 L 372.39 617.69 L 373.4 619.43 L 373.31 620.14 L 372.72 620.88 L 372.62 623.89 L 448.14 622.95 L 447.83 606.29 L 499.06 604.54 L 499.56 621.99 L 525.65 619.94 L 550.19 619.76 L 549.51 589.12 L 548.78 581.51 L 548.48 569.37 L 547.37 535.69 L 546.39 535.62 L 545.73 520.12 L 545.45 502.11 L 544.18 451.95 L 474.31 452.77 L 449.43 453.55 L 448.52 418.91 L 447.64 418.49 L 446.82 417.88 L 445.67 417.55 L 444.35 413.41 L 444.23 411.81 L 444.89 410.55 L 445.32 409.82 L 445.83 409.28 L 446.98 409.42 L 446.77 407.56 L 446.63 406.06 L 447.24 405.59 L 447.95 406.12 L 447.65 404.62 L 447.53 403.45 L 448.39 402.01 L 448.91 401.73 L 449.06 400.67 L 446.49 400.01 L 442.99 400.72 L 440.26 400.51 L 436.76 397.85 L 435.42 396.98 L 434.2 396.93 L 433.49 397.12 L 433.25 397.74 L 431.57 401.17 L 429.66 402.55 L 428.42 401.87 L 426.89 400.56 L 425.92 400.06 L 425.55 399.26 L 424.53 397.15 L 422.91 395.59 L 420.94 394.39 L 416.42 392.8 L 414.71 390.89 L 413.46 385.84 L 413.46 382.38 L 414.21 380.67 L 413.84 379.79 L 410.76 376.11 L 406.99 368.65 L 404.41 367.46 L 403.37 367.57 L 376.93 379.92 L 375.35 380.22 L 372.77 378.67 L 370.13 378.38 L 368.25 377.18 L 367.92 377.91 L 365.08 376.81 L 364.89 376.1 L 364.68 375.03 L 363.62 374.7 L 363.69 381.46 L 340.3 381.72 L 330.21 381.86 L 330.4 398.84 L 331.46 398.89 Z",
      "bonusAnchor": {
        "x": 384.83,
        "y": 511.42
      }
    },
    {
      "id": "west-central",
      "name": "West Central",
      "bonus": 3,
      "territoryIds": [
        "todd",
        "morrison",
        "stearns",
        "benton",
        "sherburne"
      ],
      "color": "#B8F000",
      "shape": "M 268.52 600.43 L 268.76 634.19 L 268.67 668.11 L 269.73 668.09 L 269.75 698.7 L 269.89 701.45 L 270.06 735.05 L 270.95 735.23 L 271.02 768.64 L 321.24 768.12 L 321.7 784.89 L 373.43 784.39 L 373.54 792.77 L 389.98 792.41 L 389.98 789.83 L 390.91 789.35 L 390.47 788.25 L 391.43 787.69 L 395.0 787.12 L 396.86 786.01 L 400.01 785.73 L 400.74 786.25 L 401.28 787.12 L 401.43 787.45 L 401.87 788.96 L 403.64 788.96 L 410.27 781.97 L 411.21 780.44 L 412.1 780.33 L 412.8 779.6 L 412.85 778.63 L 413.77 776.14 L 414.02 775.08 L 413.96 772.95 L 416.0 769.46 L 416.66 767.05 L 418.21 765.16 L 418.89 764.27 L 420.18 766.36 L 421.72 768.27 L 423.06 769.04 L 424.32 769.09 L 424.49 769.18 L 425.38 769.33 L 426.53 769.13 L 427.61 770.26 L 427.89 770.69 L 428.62 771.37 L 429.33 771.89 L 431.05 773.61 L 431.66 773.42 L 432.1 772.8 L 432.71 772.26 L 434.38 772.31 L 434.72 772.12 L 435.61 772.01 L 436.33 772.43 L 437.25 773.48 L 437.63 774.71 L 439.32 775.63 L 440.33 776.76 L 440.8 777.98 L 441.08 778.7 L 444.57 780.82 L 447.24 781.03 L 448.58 781.6 L 452.02 785.5 L 457.59 788.48 L 459.8 788.6 L 461.28 787.76 L 462.17 787.57 L 462.69 787.73 L 462.97 787.73 L 463.68 788.15 L 464.76 788.74 L 465.46 788.55 L 465.89 788.27 L 467.04 788.08 L 467.21 787.97 L 468.52 786.98 L 469.25 787.66 L 469.42 788.02 L 471.04 788.69 L 474.66 788.42 L 475.83 788.93 L 480.79 789.15 L 483.43 789.1 L 483.96 789.0 L 484.13 788.37 L 484.91 787.92 L 485.83 789.66 L 486.5 790.96 L 486.72 793.52 L 488.01 795.35 L 488.91 796.13 L 490.32 796.36 L 490.6 796.88 L 491.16 797.75 L 491.96 797.91 L 492.22 798.0 L 492.06 764.93 L 491.21 737.19 L 457.36 737.82 L 455.75 687.6 L 454.75 656.45 L 448.92 656.58 L 448.14 622.95 L 372.62 623.89 L 372.93 622.11 L 372.72 620.88 L 373.31 620.14 L 373.02 618.74 L 369.83 614.11 L 369.54 613.04 L 369.61 611.72 L 369.74 610.38 L 370.01 609.95 L 370.27 609.84 L 370.35 609.49 L 370.58 608.42 L 371.64 608.05 L 372.6 607.58 L 373.36 606.68 L 374.41 605.32 L 375.0 604.69 L 375.07 604.07 L 375.49 602.9 L 375.84 602.55 L 377.05 601.98 L 376.86 601.02 L 376.32 600.58 L 376.15 600.41 L 375.96 599.61 L 375.64 597.59 L 374.3 596.72 L 370.84 596.27 L 369.41 595.07 L 369.03 594.01 L 367.4 591.74 L 365.88 591.07 L 364.0 590.13 L 359.81 591.73 L 357.28 593.66 L 354.29 593.62 L 352.81 594.37 L 350.79 594.77 L 350.27 595.4 L 350.45 595.66 L 349.49 596.04 L 347.97 595.54 L 343.14 592.11 L 342.08 591.59 L 341.29 591.97 L 339.97 592.35 L 339.17 592.01 L 338.07 590.44 L 337.41 587.88 L 336.09 587.83 L 334.94 587.76 L 334.84 587.67 L 334.4 587.41 L 333.76 586.72 L 333.48 586.19 L 331.89 585.79 L 329.98 586.89 L 324.66 585.78 L 323.82 583.39 L 323.8 583.22 L 267.19 583.36 L 267.19 600.38 L 268.52 600.43 Z",
      "bonusAnchor": {
        "x": 374.53,
        "y": 698.12
      }
    },
    {
      "id": "east-central",
      "name": "East Central",
      "bonus": 3,
      "territoryIds": [
        "mille-lacs",
        "kanabec",
        "pine",
        "isanti",
        "chisago"
      ],
      "color": "#FF6B6B",
      "shape": "M 549.51 589.12 L 550.19 619.76 L 525.65 619.94 L 499.56 621.99 L 499.06 604.54 L 447.83 606.29 L 448.14 622.95 L 448.92 656.58 L 454.75 656.45 L 455.75 687.6 L 457.36 737.82 L 491.21 737.19 L 492.06 764.93 L 543.87 763.77 L 558.91 763.73 L 559.53 785.92 L 597.05 785.14 L 600.76 781.78 L 602.36 779.17 L 602.92 777.62 L 602.38 773.41 L 602.88 772.27 L 605.14 770.26 L 609.34 764.67 L 609.83 762.9 L 609.51 760.6 L 609.53 759.66 L 609.56 756.09 L 608.45 754.26 L 607.39 753.45 L 606.5 753.18 L 604.33 751.62 L 601.72 746.83 L 598.84 743.53 L 598.06 742.24 L 598.31 738.88 L 597.59 737.12 L 594.51 734.44 L 591.47 732.75 L 590.14 732.79 L 585.83 734.46 L 581.58 733.36 L 578.74 733.26 L 576.67 731.99 L 576.47 730.84 L 576.62 729.5 L 576.15 728.37 L 576.01 727.59 L 576.24 724.92 L 575.66 719.72 L 576.85 714.12 L 577.75 705.33 L 578.17 703.78 L 579.11 703.15 L 582.43 701.52 L 582.78 701.33 L 586.45 697.72 L 588.49 695.29 L 590.0 689.35 L 592.14 686.73 L 592.35 685.44 L 591.62 684.06 L 591.08 682.01 L 591.83 681.07 L 594.2 678.84 L 594.96 674.53 L 596.03 672.28 L 596.76 671.24 L 598.17 669.67 L 601.96 667.29 L 602.41 666.54 L 602.85 665.15 L 604.55 663.82 L 605.46 663.35 L 607.01 663.23 L 607.56 661.88 L 608.89 661.7 L 611.77 660.22 L 612.21 659.89 L 614.05 659.58 L 617.03 657.94 L 618.7 657.8 L 619.14 657.35 L 618.91 655.75 L 618.98 654.78 L 619.73 653.35 L 621.22 651.99 L 621.83 651.66 L 622.34 651.5 L 623.92 651.56 L 624.37 651.8 L 625.78 652.03 L 626.69 652.81 L 629.07 652.98 L 630.57 652.16 L 630.73 651.64 L 630.9 650.09 L 631.84 649.22 L 632.47 647.61 L 633.16 647.05 L 633.23 646.25 L 633.84 644.82 L 636.85 643.06 L 638.87 643.5 L 640.33 644.47 L 644.4 645.34 L 645.53 644.25 L 646.87 641.2 L 646.37 639.6 L 647.36 636.14 L 647.95 635.51 L 649.87 634.12 L 653.12 633.2 L 651.17 580.31 L 650.58 566.11 L 548.48 569.37 L 548.78 581.51 L 549.51 589.12 Z",
      "bonusAnchor": {
        "x": 541.06,
        "y": 698.6
      }
    },
    {
      "id": "west",
      "name": "West",
      "bonus": 5,
      "territoryIds": [
        "grant",
        "stevens",
        "pope",
        "douglas",
        "swift",
        "chippewa",
        "lac-qui-parle",
        "yellow-medicine",
        "kandiyohi"
      ],
      "color": "#00D4E8",
      "shape": "M 119.05 666.97 L 118.87 700.79 L 118.61 734.58 L 120.13 734.55 L 119.95 767.98 L 136.66 768.2 L 136.5 801.53 L 138.45 801.58 L 138.12 812.89 L 138.14 813.33 L 137.06 812.56 L 133.3 810.51 L 132.26 811.13 L 127.07 808.77 L 124.86 808.45 L 123.22 806.0 L 122.15 805.23 L 117.27 805.15 L 114.7 804.49 L 113.48 801.15 L 112.66 800.1 L 103.51 797.98 L 97.59 797.82 L 96.7 798.01 L 95.99 797.49 L 94.2 795.56 L 90.67 795.54 L 89.99 851.73 L 89.53 885.22 L 89.12 918.85 L 139.1 919.51 L 206.63 919.9 L 206.53 936.83 L 207.76 936.81 L 240.57 936.78 L 240.31 906.69 L 239.49 906.18 L 237.8 905.77 L 237.78 904.64 L 237.59 904.18 L 237.24 904.2 L 235.1 903.37 L 235.26 902.57 L 234.7 901.07 L 233.89 900.48 L 232.28 900.32 L 231.92 899.71 L 231.55 899.02 L 230.49 898.68 L 229.41 898.09 L 228.8 898.37 L 227.39 898.75 L 226.92 898.23 L 226.28 897.1 L 225.58 896.93 L 224.94 896.06 L 224.31 895.81 L 223.71 896.27 L 223.34 869.61 L 255.57 869.31 L 322.79 868.87 L 322.32 802.03 L 321.71 801.95 L 321.7 784.89 L 321.24 768.12 L 271.02 768.64 L 270.95 735.23 L 270.06 735.05 L 269.89 701.45 L 269.75 698.7 L 269.73 668.09 L 268.67 668.11 L 268.76 634.19 L 184.83 634.28 L 142.19 633.94 L 117.9 633.42 L 117.87 650.16 L 117.73 666.99 L 119.05 666.97 Z",
      "bonusAnchor": {
        "x": 185.02,
        "y": 765.63
      }
    },
    {
      "id": "bois-de-sioux",
      "name": "Bois de Sioux",
      "bonus": 1,
      "territoryIds": [
        "wilkin",
        "traverse",
        "big-stone"
      ],
      "color": "#1A237E",
      "shape": "M 49.4 532.37 L 49.21 532.54 L 50.47 532.98 L 49.46 533.43 L 49.56 533.78 L 51.15 533.67 L 50.36 534.39 L 50.36 534.56 L 51.16 534.82 L 50.9 535.76 L 50.83 535.88 L 51.63 536.32 L 51.3 537.4 L 51.21 538.01 L 52.64 537.61 L 53.27 537.94 L 52.89 539.68 L 54.0 540.18 L 53.29 540.72 L 53.11 540.83 L 54.17 541.24 L 53.58 541.96 L 53.58 542.15 L 54.45 542.13 L 54.24 542.7 L 54.94 543.98 L 54.31 545.18 L 54.26 545.59 L 55.25 547.35 L 54.47 547.89 L 54.38 548.43 L 55.46 549.65 L 54.85 550.0 L 54.97 551.25 L 55.69 552.12 L 55.08 552.71 L 55.18 553.11 L 56.17 554.52 L 55.55 554.61 L 55.55 554.8 L 56.45 555.98 L 55.51 556.31 L 55.27 556.85 L 56.23 557.79 L 56.33 559.03 L 55.72 559.22 L 55.55 559.72 L 55.91 560.46 L 55.93 561.08 L 58.51 562.54 L 57.55 563.27 L 57.57 563.54 L 58.49 563.4 L 59.08 565.01 L 58.49 565.57 L 58.7 566.56 L 57.97 566.79 L 57.88 567.16 L 58.78 568.3 L 58.07 568.39 L 58.4 569.37 L 59.86 569.26 L 59.71 570.41 L 60.47 571.19 L 60.0 572.18 L 59.92 572.62 L 61.33 572.43 L 61.17 573.49 L 61.17 573.8 L 62.14 574.01 L 62.25 574.45 L 62.42 574.88 L 63.15 575.42 L 63.9 577.96 L 64.75 578.34 L 64.53 579.28 L 65.08 580.96 L 66.89 582.87 L 67.69 583.65 L 67.59 584.45 L 67.61 585.62 L 68.53 585.95 L 69.77 585.74 L 71.19 586.78 L 71.3 588.02 L 71.66 588.65 L 73.18 589.76 L 73.4 590.16 L 73.0 590.44 L 72.98 590.61 L 73.72 591.64 L 73.87 593.78 L 73.73 594.74 L 73.16 595.52 L 73.72 596.51 L 72.95 597.03 L 74.03 597.73 L 73.42 598.36 L 73.33 598.53 L 73.96 598.97 L 73.47 601.19 L 73.12 601.65 L 73.85 603.54 L 74.06 604.55 L 73.98 604.81 L 74.17 605.35 L 75.32 605.51 L 75.49 605.94 L 73.84 606.92 L 73.52 609.43 L 74.46 613.15 L 75.28 613.65 L 74.79 615.97 L 74.71 616.06 L 75.6 616.4 L 74.92 617.66 L 75.02 619.5 L 76.19 620.02 L 76.45 621.17 L 76.08 625.4 L 77.02 627.18 L 78.07 631.68 L 79.01 639.9 L 78.1 643.64 L 76.05 647.73 L 75.91 649.35 L 75.98 649.57 L 76.24 650.44 L 76.47 655.8 L 78.01 663.56 L 78.29 664.43 L 77.35 667.72 L 77.37 672.37 L 77.35 672.51 L 75.04 686.95 L 72.9 690.59 L 71.91 692.0 L 67.9 695.86 L 65.38 701.78 L 62.87 705.05 L 54.12 709.61 L 47.47 716.07 L 40.53 719.84 L 38.04 723.71 L 37.12 728.77 L 37.31 730.11 L 39.21 733.17 L 39.49 733.52 L 49.06 746.64 L 50.41 749.63 L 51.21 753.48 L 53.29 758.25 L 58.38 765.37 L 60.98 767.61 L 68.56 768.03 L 69.87 768.15 L 76.69 772.94 L 83.79 776.02 L 85.31 777.43 L 87.34 780.45 L 88.98 786.13 L 90.74 788.16 L 90.67 795.51 L 94.2 795.56 L 96.7 798.01 L 103.51 797.98 L 111.97 799.86 L 113.11 800.45 L 114.32 803.25 L 114.7 804.49 L 115.76 804.9 L 122.15 805.23 L 123.22 806.0 L 124.86 808.45 L 127.07 808.77 L 132.26 811.13 L 133.3 810.51 L 135.18 811.45 L 137.06 812.56 L 138.14 813.33 L 138.19 811.46 L 138.45 801.58 L 136.5 801.53 L 136.66 768.2 L 119.95 767.98 L 120.13 734.55 L 118.61 734.58 L 118.87 700.79 L 119.05 666.97 L 117.73 666.99 L 117.87 650.16 L 117.9 633.42 L 118.42 599.31 L 116.32 599.35 L 116.86 532.49 L 49.98 531.6 L 49.4 532.37 Z",
      "bonusAnchor": {
        "x": 74.73,
        "y": 653.94
      }
    },
    {
      "id": "southwest",
      "name": "Southwest",
      "bonus": 6,
      "territoryIds": [
        "lincoln",
        "lyon",
        "redwood",
        "renville",
        "pipestone",
        "murray",
        "cottonwood",
        "brown",
        "rock",
        "nobles",
        "jackson",
        "martin",
        "watonwan"
      ],
      "color": "#D2B48C",
      "shape": "M 240.31 906.69 L 240.57 936.78 L 207.76 936.81 L 206.53 936.83 L 206.63 919.9 L 139.1 919.51 L 89.12 918.85 L 88.89 935.72 L 87.99 1002.65 L 87.2 1069.7 L 86.23 1137.15 L 138.31 1137.69 L 142.75 1137.7 L 194.02 1137.77 L 226.91 1137.9 L 307.67 1137.6 L 310.96 1137.58 L 369.61 1137.09 L 396.7 1136.62 L 395.83 1069.75 L 378.71 1069.94 L 378.22 1019.73 L 378.29 1003.08 L 377.75 1003.1 L 377.82 989.87 L 376.78 990.5 L 376.32 990.25 L 373.63 988.72 L 372.65 988.57 L 372.27 987.87 L 371.07 985.35 L 370.42 984.83 L 370.42 984.13 L 369.88 983.87 L 369.08 983.89 L 368.53 983.19 L 368.94 982.04 L 369.1 981.15 L 368.04 981.0 L 368.2 980.28 L 368.09 979.41 L 367.38 979.43 L 366.49 978.93 L 365.83 977.17 L 362.66 974.24 L 361.67 973.37 L 360.94 972.87 L 360.92 972.16 L 360.49 972.17 L 359.51 972.63 L 357.46 971.79 L 356.99 970.22 L 355.49 970.96 L 354.07 970.9 L 353.18 970.22 L 352.43 969.09 L 351.73 969.2 L 349.51 969.23 L 348.62 968.73 L 346.91 968.33 L 346.46 967.18 L 345.64 967.02 L 342.48 967.54 L 342.35 966.4 L 340.56 965.11 L 339.33 965.67 L 338.42 964.71 L 337.53 964.92 L 336.38 965.37 L 335.76 964.86 L 336.09 964.06 L 335.55 962.93 L 334.66 962.95 L 333.77 963.14 L 333.76 962.34 L 333.83 961.56 L 332.76 961.66 L 331.79 961.33 L 331.77 960.62 L 332.54 959.73 L 332.52 958.84 L 331.72 958.43 L 328.5 957.52 L 325.53 955.21 L 324.03 955.24 L 322.97 955.87 L 319.92 954.09 L 318.84 953.14 L 342.6 953.07 L 341.05 902.29 L 359.3 902.08 L 359.01 868.35 L 358.38 868.28 L 322.79 868.87 L 255.57 869.31 L 223.34 869.61 L 223.71 896.27 L 224.31 895.81 L 224.94 896.06 L 226.28 897.1 L 227.39 898.75 L 228.8 898.37 L 229.41 898.09 L 230.49 898.68 L 231.55 899.02 L 231.92 899.71 L 232.28 900.32 L 233.09 900.41 L 233.89 900.48 L 235.24 901.76 L 235.26 902.57 L 235.1 903.37 L 236.62 904.03 L 237.24 904.2 L 237.59 904.18 L 237.7 905.16 L 237.8 905.77 L 238.6 906.03 L 239.49 906.18 L 240.31 906.69 Z",
      "bonusAnchor": {
        "x": 223.86,
        "y": 1016.78
      }
    },
    {
      "id": "metro",
      "name": "Twin Cities Metro",
      "bonus": 5,
      "territoryIds": [
        "anoka",
        "hennepin",
        "ramsey",
        "washington",
        "carver",
        "scott",
        "dakota",
        "wright"
      ],
      "color": "#00695C",
      "shape": "M 492.22 798.0 L 491.96 797.91 L 491.16 797.75 L 490.9 797.58 L 490.53 797.32 L 490.32 796.36 L 489.89 796.27 L 488.55 795.96 L 486.72 793.52 L 486.2 790.27 L 484.91 787.92 L 484.2 788.02 L 483.96 789.0 L 482.55 789.12 L 476.87 788.72 L 475.29 788.75 L 474.66 788.42 L 471.65 788.58 L 469.79 788.35 L 469.42 788.02 L 468.52 786.98 L 467.56 787.45 L 467.21 787.97 L 466.43 788.18 L 465.89 788.27 L 464.31 788.58 L 463.68 788.15 L 462.97 787.73 L 462.43 787.66 L 461.72 787.66 L 460.58 788.13 L 459.37 788.7 L 457.94 788.63 L 452.02 785.5 L 448.85 782.14 L 448.39 781.25 L 447.67 781.1 L 444.57 780.82 L 441.62 779.31 L 440.88 778.35 L 440.43 777.46 L 439.68 775.89 L 438.26 775.04 L 437.33 774.0 L 436.86 772.78 L 436.33 772.43 L 435.09 771.93 L 434.72 772.12 L 433.85 772.31 L 432.44 772.43 L 432.1 772.8 L 431.05 773.61 L 430.15 772.76 L 428.88 771.46 L 428.34 771.13 L 427.89 770.69 L 427.43 769.82 L 425.99 769.14 L 424.58 769.35 L 424.49 769.18 L 423.34 769.02 L 422.18 768.69 L 420.65 767.05 L 418.99 764.53 L 418.89 764.27 L 417.51 765.89 L 414.21 772.33 L 413.91 774.28 L 414.1 775.42 L 412.92 777.65 L 412.8 779.6 L 412.1 780.33 L 410.78 780.98 L 406.85 785.99 L 403.64 788.96 L 401.87 788.96 L 401.43 787.45 L 401.19 787.03 L 400.74 786.25 L 399.43 785.5 L 396.86 786.01 L 395.0 787.12 L 391.43 787.69 L 390.47 788.25 L 390.91 789.35 L 389.98 789.83 L 389.98 792.41 L 390.33 803.53 L 391.11 803.51 L 391.74 851.04 L 425.12 850.81 L 425.14 867.13 L 425.85 867.2 L 426.18 901.19 L 442.75 900.98 L 443.11 909.26 L 459.68 909.06 L 459.84 915.49 L 460.13 916.56 L 459.8 917.53 L 458.7 916.14 L 458.27 916.59 L 457.49 917.15 L 456.42 917.6 L 455.97 917.01 L 455.07 916.57 L 454.02 917.13 L 449.73 919.27 L 449.39 919.9 L 448.58 919.55 L 447.79 919.57 L 447.72 920.54 L 446.52 922.61 L 445.72 922.63 L 444.84 922.39 L 444.87 923.62 L 444.07 923.64 L 443.83 924.53 L 443.11 924.63 L 442.0 925.8 L 442.45 926.41 L 442.75 927.62 L 442.49 928.25 L 441.98 928.88 L 442.54 930.2 L 441.86 931.54 L 442.5 932.41 L 442.62 933.91 L 440.92 933.05 L 440.4 933.77 L 440.78 934.65 L 493.75 933.14 L 527.77 932.41 L 527.77 946.52 L 561.26 945.62 L 561.24 937.06 L 561.86 937.47 L 562.47 937.47 L 562.8 936.48 L 564.95 936.88 L 567.85 936.01 L 570.1 937.0 L 571.68 936.62 L 573.66 937.98 L 574.27 937.44 L 574.79 937.07 L 576.05 937.39 L 577.94 935.58 L 578.01 931.17 L 595.29 930.55 L 594.18 914.09 L 602.05 913.35 L 602.15 897.33 L 595.69 893.97 L 594.27 893.25 L 593.42 892.65 L 592.01 891.36 L 592.09 887.48 L 594.55 883.35 L 595.1 880.17 L 595.21 879.42 L 597.02 875.23 L 596.74 871.64 L 596.55 870.48 L 597.19 868.2 L 597.1 866.51 L 595.78 863.71 L 595.33 862.24 L 596.39 861.11 L 597.75 859.77 L 598.15 857.21 L 598.06 851.7 L 597.07 849.47 L 596.3 848.1 L 595.52 844.3 L 595.97 837.39 L 595.07 835.88 L 591.15 832.4 L 590.67 831.15 L 590.72 829.15 L 591.05 828.24 L 595.8 823.72 L 596.23 823.18 L 597.89 821.63 L 598.53 819.75 L 597.35 815.01 L 597.3 809.62 L 595.75 807.44 L 595.26 806.8 L 595.03 803.67 L 596.44 800.01 L 595.5 794.11 L 596.22 791.09 L 595.09 788.46 L 595.12 786.34 L 596.03 785.71 L 596.51 785.43 L 597.05 785.14 L 590.84 785.2 L 559.53 785.92 L 558.91 763.73 L 543.87 763.77 L 492.06 764.93 L 492.22 798.0 Z",
      "bonusAnchor": {
        "x": 521.46,
        "y": 882.87
      }
    },
    {
      "id": "south-central",
      "name": "South Central",
      "bonus": 5,
      "territoryIds": [
        "meeker",
        "mcleod",
        "sibley",
        "le-sueur",
        "nicollet",
        "blue-earth",
        "waseca",
        "steele",
        "rice",
        "faribault",
        "freeborn"
      ],
      "color": "#4A148C",
      "shape": "M 322.79 868.87 L 358.38 868.28 L 359.01 868.35 L 359.3 902.08 L 341.05 902.29 L 342.6 953.07 L 318.84 953.14 L 322.97 955.87 L 324.03 955.24 L 325.53 955.21 L 326.88 956.32 L 328.5 957.52 L 330.21 958.01 L 332.52 958.84 L 332.54 959.73 L 331.77 960.62 L 331.79 961.33 L 332.76 961.66 L 333.83 961.56 L 333.76 962.34 L 333.77 963.14 L 334.66 962.95 L 335.55 962.93 L 336.09 964.06 L 335.76 964.86 L 336.38 965.37 L 337.53 964.92 L 338.42 964.71 L 339.33 965.67 L 340.56 965.11 L 341.73 965.79 L 342.35 966.4 L 342.48 967.54 L 343.97 967.34 L 346.46 967.18 L 346.91 968.33 L 347.9 968.66 L 350.57 969.13 L 352.43 969.09 L 354.07 970.9 L 355.49 970.96 L 356.99 970.22 L 357.44 970.83 L 357.46 971.79 L 359.51 972.63 L 360.92 972.16 L 360.94 972.87 L 361.67 973.37 L 366.47 978.04 L 366.49 978.93 L 367.38 979.43 L 368.09 979.41 L 368.2 980.28 L 368.04 981.0 L 369.1 981.15 L 368.51 982.49 L 369.08 983.89 L 369.88 983.87 L 370.42 984.13 L 370.42 984.83 L 371.82 987.0 L 372.65 988.57 L 375.42 989.65 L 376.32 990.25 L 376.78 990.5 L 377.3 990.05 L 377.82 989.87 L 377.75 1003.1 L 378.29 1003.08 L 378.22 1019.73 L 378.71 1069.94 L 395.83 1069.75 L 396.7 1136.62 L 476.99 1135.06 L 481.17 1134.99 L 532.42 1134.01 L 565.38 1133.04 L 563.4 1065.71 L 564.01 1065.69 L 562.02 998.68 L 562.82 998.66 L 561.26 945.62 L 527.77 946.52 L 527.77 932.41 L 493.75 933.14 L 440.78 934.65 L 440.4 933.77 L 440.92 933.05 L 442.62 933.91 L 442.87 933.28 L 442.5 932.41 L 441.86 931.54 L 442.02 930.74 L 442.52 929.49 L 441.98 928.88 L 442.49 928.25 L 442.75 927.62 L 442.0 925.8 L 443.11 924.63 L 443.83 924.53 L 444.07 923.64 L 444.87 923.62 L 444.84 922.39 L 445.72 922.63 L 446.52 922.61 L 447.13 921.62 L 447.79 919.57 L 448.58 919.55 L 449.39 919.9 L 449.73 919.27 L 452.54 917.97 L 455.52 916.66 L 455.97 917.01 L 456.42 917.6 L 457.14 917.41 L 457.49 917.15 L 458.27 916.59 L 458.7 916.14 L 459.35 917.27 L 459.8 917.53 L 460.13 916.56 L 459.84 915.49 L 459.68 909.06 L 443.11 909.26 L 442.75 900.98 L 426.18 901.19 L 425.85 867.2 L 425.14 867.13 L 425.12 850.81 L 391.74 851.04 L 391.11 803.51 L 390.33 803.53 L 390.02 793.56 L 389.98 792.41 L 373.54 792.77 L 373.43 784.39 L 321.7 784.89 L 321.71 801.95 L 322.32 802.03 L 322.79 868.87 Z",
      "bonusAnchor": {
        "x": 457.84,
        "y": 1005.75
      }
    },
    {
      "id": "southeast",
      "name": "Southeast",
      "bonus": 4,
      "territoryIds": [
        "goodhue",
        "wabasha",
        "olmsted",
        "dodge",
        "mower",
        "fillmore",
        "winona",
        "houston"
      ],
      "color": "#6B9E00",
      "shape": "M 595.29 930.55 L 578.01 931.17 L 577.94 935.58 L 576.05 937.39 L 574.79 937.07 L 574.27 937.44 L 573.66 937.98 L 572.41 937.3 L 571.68 936.62 L 570.1 937.0 L 567.85 936.01 L 565.83 936.41 L 564.34 937.07 L 562.8 936.48 L 562.47 937.47 L 561.86 937.47 L 561.24 937.06 L 561.26 945.62 L 562.82 998.66 L 562.02 998.68 L 564.01 1065.69 L 563.4 1065.71 L 565.38 1133.04 L 645.03 1130.59 L 649.75 1130.41 L 701.87 1128.46 L 751.04 1126.29 L 822.85 1122.79 L 823.04 1120.14 L 821.58 1118.39 L 821.05 1117.95 L 819.59 1115.34 L 819.26 1113.17 L 820.25 1109.56 L 820.37 1107.01 L 819.9 1105.79 L 816.93 1102.83 L 815.03 1099.75 L 814.77 1097.03 L 815.36 1094.46 L 814.58 1093.33 L 813.71 1092.28 L 814.18 1081.81 L 815.57 1078.21 L 816.49 1070.25 L 815.9 1068.83 L 814.32 1067.17 L 813.76 1066.13 L 811.52 1058.63 L 810.04 1056.07 L 807.71 1056.09 L 748.03 1059.06 L 809.85 1055.91 L 806.89 1052.69 L 806.61 1052.26 L 804.85 1048.5 L 799.63 1043.17 L 797.94 1039.43 L 796.59 1037.76 L 796.12 1037.48 L 791.54 1033.26 L 790.86 1032.51 L 787.45 1028.24 L 783.78 1026.64 L 782.32 1026.56 L 781.32 1026.35 L 780.18 1026.17 L 779.18 1025.74 L 776.14 1024.17 L 768.72 1023.72 L 766.32 1022.87 L 765.71 1022.57 L 765.33 1022.27 L 764.88 1021.93 L 762.51 1019.26 L 760.79 1018.45 L 760.08 1018.12 L 756.77 1015.63 L 754.35 1012.79 L 749.76 1010.35 L 748.71 1009.57 L 747.65 1006.3 L 746.26 1004.8 L 742.4 1003.95 L 735.3 1000.44 L 733.99 999.63 L 731.41 997.23 L 728.98 994.4 L 727.79 993.63 L 727.31 993.4 L 725.85 992.29 L 725.32 991.72 L 722.5 987.04 L 722.24 985.05 L 722.97 982.51 L 721.91 980.87 L 721.11 979.48 L 721.03 977.9 L 718.31 976.14 L 717.16 974.99 L 717.11 974.37 L 717.27 972.97 L 717.67 972.49 L 718.01 972.03 L 718.35 970.47 L 716.66 967.08 L 713.94 965.21 L 711.84 961.94 L 710.5 960.95 L 707.43 960.18 L 706.72 959.84 L 701.24 957.17 L 700.44 956.58 L 698.35 954.72 L 695.83 953.9 L 694.92 953.55 L 693.84 952.81 L 688.55 951.76 L 680.93 949.41 L 678.42 949.12 L 677.17 948.96 L 675.05 947.92 L 672.4 945.79 L 671.72 945.1 L 669.38 942.57 L 665.81 940.24 L 664.56 938.38 L 662.69 931.17 L 661.13 929.07 L 657.91 927.26 L 653.96 925.95 L 649.22 926.25 L 648.3 925.88 L 646.21 925.1 L 642.89 924.74 L 634.69 925.08 L 632.62 923.81 L 631.84 923.99 L 629.23 924.87 L 628.64 922.79 L 627.96 921.34 L 627.59 920.82 L 625.75 918.58 L 623.09 918.02 L 622.37 917.69 L 619.99 916.77 L 618.87 916.28 L 618.49 915.15 L 618.79 913.28 L 617.67 911.37 L 611.65 906.69 L 608.33 902.77 L 602.36 897.45 L 602.05 913.35 L 594.18 914.09 L 595.29 930.55 Z",
      "bonusAnchor": {
        "x": 693.35,
        "y": 1017.13
      }
    }
  ],
  "territories": [
    {
      "id": "cook",
      "name": "Cook",
      "regionId": "arrowhead",
      "adjacencies": [
        "lake"
      ],
      "shape": "M 992.31 239.7 L 998.33 238.98 L 999.2 238.41 L 999.98 238.48 L 999.39 239.12 L 991.32 241.61 L 986.74 243.91 L 985.59 243.49 L 985.12 242.34 L 984.67 242.27 L 983.8 242.4 L 981.92 243.79 L 981.33 244.71 L 981.47 245.86 L 982.11 249.32 L 980.42 248.92 L 979.85 247.51 L 976.47 248.78 L 976.14 249.6 L 977.08 250.99 L 973.9 252.98 L 969.16 258.21 L 966.92 259.54 L 963.94 262.48 L 956.79 266.18 L 948.11 269.04 L 944.14 273.98 L 940.92 274.97 L 937.6 277.84 L 932.65 279.62 L 931.47 280.89 L 930.53 281.55 L 928.41 281.53 L 918.19 285.87 L 914.85 288.37 L 911.11 289.1 L 906.34 291.14 L 898.86 293.31 L 897.9 293.8 L 896.23 296.26 L 895.01 296.83 L 891.17 297.21 L 885.7 299.25 L 883.86 299.13 L 882.9 299.7 L 881.3 301.7 L 877.8 302.43 L 872.77 304.36 L 868.82 307.34 L 868.42 308.25 L 863.27 311.88 L 860.42 313.4 L 857.55 314.2 L 856.61 315.29 L 852.93 318.51 L 848.93 319.97 L 841.64 325.35 L 822.15 343.12 L 811.73 353.23 L 809.88 355.68 L 808.14 356.71 L 807.29 340.18 L 804.29 284.93 L 802.28 259.03 L 801.6 240.06 L 800.99 240.08 L 799.53 215.39 L 799.79 215.39 L 800.99 214.55 L 806.94 208.93 L 814.14 206.56 L 817.57 203.69 L 818.72 204.28 L 819.63 204.89 L 820.93 204.67 L 822.48 203.64 L 823.52 203.61 L 823.89 204.04 L 824.92 214.38 L 825.26 217.13 L 825.79 217.11 L 826.27 215.58 L 826.97 215.39 L 827.23 215.65 L 828.74 216.14 L 828.95 217.48 L 829.63 219.32 L 831.89 218.9 L 832.52 219.15 L 832.59 221.55 L 831.76 222.56 L 830.19 223.24 L 829.79 224.23 L 832.28 225.67 L 833.46 226.98 L 835.53 231.38 L 836.63 232.51 L 838.18 232.01 L 842.65 231.52 L 845.07 230.37 L 850.64 229.4 L 853.91 227.43 L 856.43 226.56 L 857.7 225.36 L 861.48 225.24 L 861.76 225.85 L 861.08 226.59 L 860.43 228.49 L 861.18 229.71 L 863.81 229.73 L 869.83 229 L 873.9 227.19 L 876.29 228 L 878.06 228.3 L 880.92 227.24 L 882.33 227.27 L 884.05 228.93 L 884.94 229.52 L 886.59 229.03 L 889.3 228.77 L 893.6 226.32 L 895.38 226.96 L 896.37 227.48 L 897.74 226.8 L 901.5 226.33 L 904.1 225.27 L 907.87 225.34 L 910.81 224.26 L 914.22 223.88 L 916.68 223.81 L 919.17 224.98 L 923.74 225.11 L 930.65 227.48 L 932.51 230.72 L 933.96 231.75 L 934.88 233.15 L 935.37 237.33 L 935.58 238.31 L 937.09 238.71 L 939.16 240.6 L 940.24 241.02 L 941.35 240.53 L 942.94 240.39 L 945.04 243.09 L 946.58 244.12 L 948.61 244.94 L 951.6 245.11 L 952.65 244.9 L 956.42 242.38 L 957.21 242.08 L 957.43 240.92 L 958.67 238.91 L 959.99 238.95 L 960.88 239.28 L 961.82 238.72 L 964.76 237.47 L 967.75 237.37 L 968.36 237.63 L 969.15 237.24 L 969.95 237.49 L 970.56 237.45 L 971.63 238.24 L 972.1 239.11 L 973.97 239.4 L 977.1 238.95 L 979.03 238.71 L 979.74 239.32 L 981.08 239.89 L 982.55 238.95 L 985.21 237.44 L 985.66 237.96 L 985.96 238.93 L 987.12 239.42 L 988.64 240.36 L 989.63 241.04 L 991.02 240.46 Z",
      "position": {
        "x": 845.4,
        "y": 273.1
      },
      "badgeAnchor": {
        "x": 857.79,
        "y": 270.48
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "lake",
      "name": "Lake",
      "regionId": "arrowhead",
      "adjacencies": [
        "cook",
        "saint-louis"
      ],
      "shape": "M 799.53 215.39 L 800.99 240.08 L 801.6 240.06 L 802.28 259.03 L 804.29 284.93 L 808.14 356.71 L 807.03 357.37 L 802.92 361.06 L 801.01 364.49 L 798.06 366.54 L 796.55 368.35 L 790.37 376.37 L 788.82 380.6 L 786.02 383.79 L 783.85 387.77 L 779.91 391.27 L 776.96 395.36 L 776.28 396.27 L 776.49 397.33 L 772.78 400.29 L 768.86 404.57 L 767.12 408.1 L 765.68 409.91 L 760.34 414.07 L 756.16 421.2 L 753.43 424.49 L 750.38 425.73 L 747.82 428.65 L 744.64 430.77 L 743.7 431.96 L 740.57 433.21 L 738.39 436.92 L 733.07 441.86 L 732.74 442.59 L 733.21 443.63 L 732.55 444.73 L 731.05 445.11 L 730.18 445.24 L 729.78 446.58 L 729.01 447.48 L 728.47 447.32 L 727.1 448.07 L 724.4 449.66 L 721.09 454.11 L 717.25 457.94 L 714.12 462.31 L 712.13 464.05 L 709.94 414.33 L 708.13 378.62 L 707.16 341.26 L 703.29 295.38 L 700.18 217.79 L 700.72 218.03 L 701.64 219.44 L 702.07 219.42 L 702.91 218.07 L 706.32 218.15 L 707.05 218.85 L 708.51 217.91 L 709.64 217.88 L 711.52 218.99 L 711.68 221.39 L 710.41 223.13 L 710.36 224.19 L 712.45 223.43 L 712.85 225.38 L 712.55 227.08 L 712.67 228.06 L 713.75 229.27 L 713.8 230.98 L 712.22 233.78 L 712.17 235.12 L 713.4 235.17 L 715.72 233.42 L 715.89 233.68 L 715.49 234.86 L 716.22 235.64 L 717.98 235.85 L 719.01 234.76 L 719.7 234.91 L 721.08 236.84 L 721.79 237.52 L 724.16 236.93 L 731.81 235.38 L 732.35 235.89 L 731.36 237.52 L 730.93 237.8 L 730.47 243.27 L 730.58 246.66 L 731.47 247.25 L 736.39 244.8 L 741.42 242.6 L 746.57 242.1 L 747.96 244.64 L 749.41 245.75 L 750.96 244.64 L 752.87 244.41 L 754.09 244.21 L 756.32 241.91 L 757.26 241.53 L 759.95 240.81 L 765.91 240.46 L 769.02 239.04 L 770.43 238.91 L 772.57 237.51 L 776.59 233.73 L 779.43 229.47 L 779.97 229.88 L 783.39 226.84 L 785.43 224.82 L 786.68 222.73 L 791.07 220.02 L 791.83 219.09 L 792.25 218.55 L 794.69 217.86 L 795.19 217.13 L 796.05 216.38 L 798.48 215.6 Z",
      "position": {
        "x": 754.4,
        "y": 299.1
      },
      "badgeAnchor": {
        "x": 755.85,
        "y": 320.29
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "saint-louis",
      "name": "Saint Louis",
      "regionId": "arrowhead",
      "adjacencies": [
        "aitkin",
        "carlton",
        "itasca",
        "koochiching",
        "lake"
      ],
      "shape": "M 700.18 217.79 L 701.48 250.42 L 703.29 295.38 L 707.16 341.26 L 708.13 378.62 L 712.13 464.05 L 711.78 464.22 L 710.93 465.23 L 710.15 465.7 L 709.19 465.63 L 708.57 465.56 L 707.68 465.49 L 706.32 467.04 L 698.8 472.4 L 690.15 480.72 L 686.69 483.14 L 684.85 483.54 L 675.92 491.77 L 674.35 492.52 L 673.17 494.41 L 672.86 495.86 L 672.61 496.4 L 673.08 497.62 L 673.03 498.87 L 672.6 498.87 L 673.17 500.56 L 673.05 500.57 L 670.45 501.36 L 667.97 503.31 L 667.62 504.25 L 666.77 507.41 L 662.76 507.22 L 660.54 509.08 L 659.86 510.15 L 659.93 511.33 L 660.52 511.82 L 662.08 511.9 L 663.27 512.7 L 663.15 513.92 L 660.14 517.05 L 660.08 519.04 L 660 519.79 L 659.02 520.64 L 653.61 520.34 L 652.03 520.2 L 651.14 520.4 L 648.77 517.72 L 647.73 518.1 L 646.6 498.96 L 606.99 500.17 L 597.9 499.97 L 589.12 500.63 L 545.45 502.11 L 544.18 451.95 L 544.04 435.87 L 542.72 435.99 L 540.25 369.88 L 540.3 351.28 L 538.91 317.47 L 536.63 317.43 L 535.95 283.86 L 535.8 267.37 L 534.82 267.4 L 534.21 250.3 L 533.34 250.23 L 532.51 228.02 L 531.45 169.74 L 530.38 142.42 L 544.22 142.7 L 547.07 141.38 L 548.57 141.34 L 548.55 144.37 L 548.74 145.26 L 550.43 145.67 L 553.63 147.55 L 565.75 152.25 L 576.92 157.68 L 579.2 157.72 L 585.36 156.2 L 589.5 156.9 L 590.75 160.99 L 590.75 164.56 L 585.79 165.93 L 583.7 166 L 582.47 166.02 L 581.32 168.38 L 579.75 172.18 L 583.1 176.2 L 587.43 177.69 L 596.16 176.56 L 602.76 174.7 L 606.71 174.77 L 611.06 180.37 L 613.1 181.21 L 613.17 183.44 L 611.11 188.87 L 611.17 190.55 L 611.83 192.59 L 616.99 201.66 L 618.3 201.8 L 622.88 211.59 L 623.5 212.55 L 624.91 215.91 L 626.2 217.84 L 628.52 216 L 631.47 215.2 L 633.96 213.52 L 637.02 213.18 L 638.68 212.86 L 639.01 211.87 L 638.35 210.38 L 637.27 209.42 L 635.72 207.31 L 634.87 204.75 L 635.04 201.45 L 634.1 199.59 L 633.81 198.26 L 634.99 196.52 L 635.72 194.28 L 636.47 193.09 L 638.78 191.51 L 645.46 191.88 L 649.57 191.58 L 649.71 190.59 L 652.29 188.47 L 653.7 188.61 L 653.73 190.22 L 662.07 190.35 L 663.6 188.97 L 665.53 189.01 L 666.26 190.33 L 666.49 192.1 L 666.59 192.73 L 668.04 194.12 L 668.33 195.1 L 672.56 195.77 L 671.69 202.32 L 673.06 207.28 L 674.72 207.24 L 675.94 209.97 L 677.03 211.19 L 677.43 209.94 L 678.2 209.28 L 679.43 209.78 L 680.01 211.38 L 679.35 212.83 L 680.25 213.61 L 682.17 213.28 L 683.72 212.34 L 687.84 212.24 L 687.94 212.95 L 691.18 215.8 L 691.56 216.69 L 692.97 217.18 L 694.47 217.32 L 696.82 216.54 L 697.69 216.78 Z",
      "position": {
        "x": 619.18,
        "y": 338.31
      },
      "badgeAnchor": {
        "x": 619.18,
        "y": 338.31
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "carlton",
      "name": "Carlton",
      "regionId": "arrowhead",
      "adjacencies": [
        "aitkin",
        "pine",
        "saint-louis"
      ],
      "shape": "M 545.45 502.11 L 587.71 500.66 L 597.9 499.97 L 606.99 500.17 L 646.6 498.96 L 647.73 518.1 L 648.77 517.72 L 648.81 518.6 L 649.26 532.07 L 650.58 566.11 L 548.48 569.37 L 547.37 535.69 L 546.39 535.62 Z",
      "position": {
        "x": 598.5,
        "y": 533.9
      },
      "badgeAnchor": {
        "x": 605.21,
        "y": 533.06
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "itasca",
      "name": "Itasca",
      "regionId": "arrowhead",
      "adjacencies": [
        "aitkin",
        "beltrami",
        "cass",
        "koochiching",
        "saint-louis"
      ],
      "shape": "M 362.33 297.18 L 379 296.79 L 446.02 295.07 L 445.6 284.91 L 485.61 284.75 L 535.95 283.86 L 536.63 317.43 L 538.91 317.47 L 540.3 351.28 L 540.25 369.88 L 542.72 435.99 L 544.04 435.87 L 544.18 451.95 L 529.41 452.32 L 474.31 452.77 L 449.43 453.55 L 448.52 418.91 L 446.82 417.88 L 446.12 417.81 L 445.2 416.23 L 444.23 411.81 L 445.32 409.82 L 445.83 409.28 L 446.98 409.42 L 446.96 408.9 L 446.63 406.06 L 447.24 405.59 L 447.95 406.12 L 447.53 403.45 L 447.62 403.02 L 448.91 401.73 L 449.06 400.67 L 448.7 400.32 L 446.49 400.01 L 444.12 400.51 L 440.26 400.51 L 435.42 396.98 L 433.49 397.12 L 432.24 399.82 L 432.17 400.53 L 430.88 401.89 L 429.66 402.55 L 428.15 401.33 L 425.92 400.06 L 425.34 398.28 L 422.91 395.59 L 420.94 394.39 L 416.42 392.8 L 414.71 390.89 L 413.46 385.84 L 413.46 382.38 L 413.96 381.39 L 414.1 379.79 L 412.94 378.65 L 410.76 376.11 L 406.99 368.65 L 404.41 367.46 L 403.37 367.57 L 376.04 380.12 L 375.35 380.22 L 374.01 379.37 L 372.77 378.67 L 370.13 378.38 L 369.05 377.61 L 367.99 377.28 L 367.92 377.91 L 367.03 377.84 L 365.08 376.81 L 364.89 376.1 L 364.68 375.03 L 363.62 374.7 L 363.29 356.12 L 363.08 346.15 L 362.68 344.55 L 362.82 322.64 Z",
      "position": {
        "x": 478.8,
        "y": 347
      },
      "badgeAnchor": {
        "x": 471.36,
        "y": 352.18
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "koochiching",
      "name": "Koochiching",
      "regionId": "arrowhead",
      "adjacencies": [
        "beltrami",
        "itasca",
        "lake-of-the-woods",
        "saint-louis"
      ],
      "shape": "M 530.38 142.42 L 531.45 169.74 L 532.51 228.02 L 533.34 250.23 L 534.21 250.3 L 534.82 267.4 L 535.8 267.37 L 535.95 283.86 L 525.96 284.2 L 445.6 284.91 L 446.02 295.07 L 362.33 297.18 L 362.04 264.11 L 361.51 264.04 L 359.89 195.81 L 359.37 195.72 L 359.18 187.53 L 358.55 131.51 L 359.41 130.59 L 360.96 129.84 L 364.63 129.75 L 367.29 130.95 L 368.77 131.09 L 371.83 131.11 L 375.49 129.96 L 380.17 132 L 381.89 134.9 L 381.28 138.59 L 382.2 140.35 L 386.59 141.5 L 388.85 141.01 L 394.66 142.12 L 405.96 142.21 L 410.26 143.01 L 414.19 142.84 L 420.61 144.19 L 425.85 143.99 L 434.72 144.86 L 436.62 147.66 L 439.44 155.65 L 439.63 156.62 L 438.57 159.68 L 438.71 161.48 L 438.29 162.47 L 438.07 164.26 L 439.23 165.03 L 440.92 166.07 L 442.66 166.19 L 449.39 165.6 L 456.32 166.05 L 459.97 165.34 L 460.74 164.15 L 461.85 162.97 L 463.09 163.82 L 464.17 164.61 L 465.46 163.69 L 466.24 163.3 L 468 163.53 L 470 163.41 L 472.19 163.25 L 473.65 162.68 L 475.48 162.1 L 476.26 161.82 L 479.03 160.41 L 482.6 159.42 L 483.52 157.98 L 483.64 155.82 L 482.32 151.75 L 482.65 150.76 L 486.46 149.68 L 489.91 147.27 L 491.32 147.5 L 492.71 147.66 L 494.73 147.41 L 495.93 146.32 L 497.42 143.69 L 508.98 140.09 L 512.3 139.91 L 515.37 140.38 L 517.32 141.32 L 518.41 142.63 L 519.3 143.59 L 523.49 143.13 Z",
      "position": {
        "x": 448.11,
        "y": 221.38
      },
      "badgeAnchor": {
        "x": 448.11,
        "y": 221.38
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "lake-of-the-woods",
      "name": "Lake of the Woods",
      "regionId": "arrowhead",
      "adjacencies": [
        "beltrami",
        "koochiching",
        "roseau"
      ],
      "shape": "M 358.55 131.51 L 358.94 164.38 L 359.37 195.72 L 284.23 196.49 L 258.67 196.77 L 258.42 163.35 L 241.79 163.25 L 241.91 129.91 L 273.75 129.61 L 273.48 90.51 L 272.36 92.06 L 270.05 93.82 L 265.19 95.8 L 255.71 97.87 L 252.45 97.05 L 248.78 94.51 L 247.55 92.93 L 244.24 87.31 L 244.61 85.78 L 245.79 85.34 L 246.61 84.82 L 246.15 84.02 L 245.46 83.86 L 244.55 82.71 L 244.27 81.29 L 244.4 78.5 L 244.87 76.62 L 245.56 75.89 L 247.22 75.4 L 248.09 75.47 L 249.11 74.66 L 266.06 74.66 L 266.03 0 L 270.1 3.24 L 278.19 6.3 L 282.63 5.85 L 286.34 3.25 L 290.34 2.8 L 295.45 5.74 L 301.13 10.2 L 304.03 11.29 L 308.51 11.92 L 307.2 16.43 L 310.07 28.56 L 311.62 39.82 L 314.42 51.84 L 317.21 55.9 L 326.12 96.36 L 327.02 97.77 L 325.32 99.68 L 325.94 104.41 L 324.5 106.24 L 323.65 107.51 L 323.49 107.95 L 323.7 109.2 L 324.43 111.06 L 324.31 113.65 L 324.88 116.07 L 325.35 117.13 L 329.81 121.14 L 331.42 123.26 L 331.89 124.32 L 333.39 124.91 L 337.29 127.16 L 339.06 128.81 L 342.93 129.35 L 344.27 130.66 L 344.89 131.26 L 345.69 131.87 L 346.58 132.03 L 350.78 132.2 L 356.05 133.44 L 357.35 133.06 Z",
      "position": {
        "x": 305.4,
        "y": 155.4
      },
      "badgeAnchor": {
        "x": 302.42,
        "y": 156.8
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "kittson",
      "name": "Kittson",
      "regionId": "far-north",
      "adjacencies": [
        "marshall",
        "roseau"
      ],
      "shape": "M 106.17 73.82 L 105.53 128.67 L 107.98 128.62 L 107.15 162.15 L 49.54 161.32 L 7.4 160.2 L 7.26 159.82 L 7.8 159.06 L 10.74 159.06 L 9.68 157.91 L 6.84 157.87 L 6.44 157.12 L 6.72 156.88 L 9.76 155.8 L 9.8 155.14 L 8.21 153.64 L 8.58 153.31 L 10.34 153.24 L 10.18 151.43 L 9.29 150.69 L 9.62 150.51 L 11.29 148.91 L 11.14 148.44 L 10.01 148.37 L 9.52 147.81 L 10.48 147.08 L 12.22 147.33 L 11.76 145.81 L 12.02 145.71 L 12.74 146.42 L 13.3 146.16 L 12.27 144.73 L 12.25 143.93 L 13.17 143.46 L 13.94 144.11 L 14.91 143.92 L 14.5 141.38 L 15.85 139.69 L 16.36 138.45 L 15.33 137.86 L 15.64 137.25 L 16.29 136.57 L 16.18 135.41 L 16.58 134.34 L 17.35 133.56 L 15.4 132.43 L 14.11 130.27 L 14.3 129.84 L 15.19 129.3 L 13.64 127.56 L 12.02 125.31 L 12.84 124.69 L 11.45 123.59 L 11.59 123.19 L 12.13 121.33 L 10.44 120.46 L 9.99 119.76 L 10.55 118.96 L 10.93 117.67 L 10.18 116.7 L 9.85 115.78 L 10.95 115.13 L 9.61 114.12 L 9.34 112.85 L 8.11 112.7 L 7.94 112.44 L 9 110.8 L 7.13 111.2 L 7.15 110.96 L 9.68 109.58 L 9.1 109.06 L 5.78 108.36 L 6.28 107.56 L 7.13 106.75 L 6.39 105.04 L 6.68 104.67 L 7.73 103.93 L 7.62 102.95 L 7 102.43 L 7.41 101.84 L 7.76 101.18 L 7.2 98.95 L 6.33 98.69 L 6.2 98.06 L 7.26 96.53 L 5.17 95.66 L 5.03 93.52 L 5.64 92.98 L 3.72 91.14 L 3.15 89.74 L 2.73 87.99 L 2.58 87.12 L 2.73 85.62 L 1.62 85.18 L 0.64 82.17 L 0.97 81.22 L 1.06 79.51 L 0.14 78.83 L 0.35 75.16 L 1.5 73.72 L 0.66 72.93 L 1.51 71.82 Z",
      "position": {
        "x": 59,
        "y": 117.3
      },
      "badgeAnchor": {
        "x": 62.43,
        "y": 119.25
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "roseau",
      "name": "Roseau",
      "regionId": "far-north",
      "adjacencies": [
        "beltrami",
        "kittson",
        "lake-of-the-woods",
        "marshall"
      ],
      "shape": "M 249.11 74.66 L 248.78 75.02 L 247.22 75.4 L 246.35 75.51 L 244.87 76.62 L 244.17 80.83 L 244.55 82.71 L 244.92 83.43 L 246.15 84.02 L 246.61 84.82 L 244.61 85.78 L 244.19 86.25 L 244.67 88.44 L 248.33 94.29 L 249.25 94.7 L 252.45 97.05 L 255.71 97.87 L 265.19 95.8 L 270.05 93.82 L 272.36 92.06 L 273.48 90.51 L 273.75 129.61 L 241.91 129.91 L 241.79 163.25 L 208.36 163.58 L 107.15 162.15 L 107.98 128.62 L 105.53 128.67 L 106.17 73.82 L 115.69 73.91 L 163.58 74.59 Z",
      "position": {
        "x": 198.4,
        "y": 119.1
      },
      "badgeAnchor": {
        "x": 177.41,
        "y": 117.67
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "marshall",
      "name": "Marshall",
      "regionId": "far-north",
      "adjacencies": [
        "beltrami",
        "kittson",
        "pennington",
        "polk",
        "roseau"
      ],
      "shape": "M 7.4 160.2 L 49.54 161.32 L 107.15 162.15 L 208.36 163.58 L 208.39 197.17 L 209.45 197.15 L 209.47 234.72 L 91.38 233.52 L 9.64 231.83 L 9.68 231.62 L 9.43 230.89 L 8.25 230.53 L 8.18 229.85 L 9.01 228.73 L 9.52 227.64 L 9.24 226.58 L 9.4 226.16 L 10.32 225.38 L 9.9 223.9 L 11.02 225.57 L 11.94 225.46 L 11.83 224.66 L 10.82 223.29 L 8.27 223.5 L 8.54 222.77 L 9.52 222.33 L 11.8 222.43 L 9.05 220.69 L 9.31 220.24 L 10.01 219.2 L 8.72 218.71 L 9.19 218.21 L 11.42 217.42 L 11.07 215.84 L 11.73 215.21 L 10.89 214.53 L 9.14 214.34 L 9.21 213.82 L 9.8 213.75 L 11.4 213.32 L 12.2 211.4 L 11.59 209.75 L 10.11 209.97 L 10.88 208.55 L 12.27 209 L 12.93 208.6 L 11.64 207.43 L 11.73 205.92 L 10.16 205.71 L 10.56 204.7 L 10.86 204.25 L 12.55 203.99 L 12.55 203.22 L 11.66 202.51 L 9.83 202.47 L 10.35 202.02 L 11 201.67 L 11.36 200.21 L 9.87 198.94 L 10.04 198.66 L 10.32 198.23 L 9.22 196.85 L 8.13 195.69 L 8.13 194.56 L 10.04 194.02 L 10.01 192.94 L 10.68 191.91 L 8.02 191.69 L 7.36 189.75 L 8.47 189.28 L 9.54 189.09 L 11.35 187.46 L 10.74 185.63 L 8.51 185.72 L 8.68 185 L 9.34 184.67 L 10.68 184.53 L 11.5 185.16 L 12.39 185.07 L 12.16 184.15 L 9.87 182.74 L 10.3 182.29 L 11.64 182.84 L 12.56 181.54 L 12.2 180.37 L 9.76 181.14 L 9.41 180.88 L 9.59 180.22 L 10.49 179.73 L 11.8 178.46 L 12.08 177.43 L 11.56 176.67 L 9.85 175.87 L 9.59 175.33 L 9.83 174.54 L 11.75 174.75 L 12.11 174.13 L 10.62 173.53 L 8.28 173.88 L 7.97 173.24 L 9.12 172.84 L 10.04 172.28 L 9.94 171.12 L 10.22 170.85 L 11.24 171.39 L 11.69 171.12 L 9.31 168.73 L 9.38 167.04 L 11.56 166.73 L 12.36 165.62 L 11.76 165.2 L 9.61 165.51 L 9.07 164.8 L 9.05 163.46 L 10.62 162.71 L 8.06 161.06 L 7.5 160.38 Z",
      "position": {
        "x": 111.98,
        "y": 199.63
      },
      "badgeAnchor": {
        "x": 111.98,
        "y": 199.63
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "pennington",
      "name": "Pennington",
      "regionId": "far-north",
      "adjacencies": [
        "beltrami",
        "clearwater",
        "marshall",
        "polk",
        "red-lake"
      ],
      "shape": "M 91.38 233.52 L 209.47 234.72 L 209.77 263.97 L 210.74 263.96 L 210.81 281.06 L 193.69 280.78 L 193.58 274.73 L 93.57 274.14 L 93.55 263.17 L 91.01 263.23 Z",
      "position": {
        "x": 146.71,
        "y": 252.77
      },
      "badgeAnchor": {
        "x": 146.71,
        "y": 252.77
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "red-lake",
      "name": "Red Lake",
      "regionId": "far-north",
      "adjacencies": [
        "pennington",
        "polk"
      ],
      "shape": "M 93.57 274.14 L 193.58 274.73 L 193.69 280.78 L 193.84 297.35 L 177.08 297.51 L 176.96 314.44 L 110.14 313.48 L 110.28 296.92 L 93.17 296.52 Z",
      "position": {
        "x": 138.86,
        "y": 290.9
      },
      "badgeAnchor": {
        "x": 138.86,
        "y": 290.9
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "polk",
      "name": "Polk",
      "regionId": "northwest",
      "adjacencies": [
        "clearwater",
        "mahnomen",
        "marshall",
        "norman",
        "pennington",
        "red-lake"
      ],
      "shape": "M 9.64 231.83 L 91.38 233.52 L 91.01 263.23 L 93.55 263.17 L 93.57 274.14 L 93.17 296.52 L 110.28 296.92 L 110.14 313.48 L 176.96 314.44 L 177.08 297.51 L 193.84 297.35 L 193.69 280.78 L 210.81 281.06 L 210.74 282.23 L 211.18 331.39 L 214.52 331.51 L 214.81 364.61 L 150.3 364.37 L 146.87 364.35 L 44.03 363.24 L 43.78 362.98 L 43.78 362.23 L 44.98 361.98 L 43.94 361.06 L 45.07 360.42 L 42.95 360.19 L 42.04 359.41 L 41.59 358.22 L 42.43 357.37 L 43.52 356.71 L 42.62 355.42 L 42.9 355.18 L 44.11 355.81 L 44.81 355.65 L 43.3 354.22 L 44.1 352.93 L 42.83 352.19 L 42.83 351.87 L 44.27 351.21 L 44.29 350.74 L 42.18 350.9 L 42.44 350.15 L 43.75 349.85 L 43.38 348.53 L 44.06 347.54 L 44.48 346.2 L 43.73 345.16 L 43.92 344.6 L 44.27 344.34 L 43.77 343.01 L 43.7 342.56 L 43.44 341.76 L 42.44 341.33 L 41.43 340.47 L 41.24 339.31 L 40.67 338.16 L 39.8 336.91 L 40.09 336.04 L 40.69 335.25 L 40.43 334.24 L 39.78 330.71 L 40.18 329.96 L 38.89 328.85 L 38.72 327.84 L 37.75 326.55 L 37.29 325.58 L 36.18 324.27 L 36.3 323.72 L 36.56 323.28 L 35.67 321.24 L 34.77 321.26 L 35.01 320.64 L 35.97 319.54 L 34.79 318.06 L 34.77 315.82 L 34.89 314.68 L 33.59 313.81 L 33.59 313.26 L 34.87 313.52 L 33.92 312.46 L 34.07 311.38 L 32.18 309.79 L 31.43 309.85 L 31.36 309.48 L 31.85 308.92 L 30.78 307.97 L 30.75 307.5 L 31.22 306.63 L 29.98 305.22 L 29.15 305.15 L 29.2 304.9 L 29.04 304.24 L 27.46 303.65 L 27.48 302.75 L 28.45 302.62 L 28.37 301.2 L 29.03 300.43 L 27.93 299.39 L 28.09 299.2 L 27.76 297.77 L 26.56 296.1 L 26.07 293.26 L 25.37 291.92 L 25.3 291.47 L 24.1 290.88 L 23.53 290.44 L 23.65 289.85 L 23.02 288.48 L 23.08 287.69 L 23.77 287.24 L 23.06 286.18 L 23.3 285.47 L 23.11 284.49 L 23.37 283.76 L 24.26 283.73 L 23.55 282.26 L 23.68 281.53 L 22.19 279.78 L 21.53 278.37 L 21.09 277.48 L 20.15 277.16 L 19.37 276.56 L 19.37 274.83 L 18.99 273.41 L 18.71 271.37 L 19.59 268.38 L 19.51 267.26 L 18.71 266.38 L 18.01 265.16 L 17.99 263.99 L 18.31 263.26 L 17.56 262.25 L 17.19 256.37 L 16.53 255.6 L 13.49 251.67 L 13.77 250.17 L 13.8 249.16 L 13 248.38 L 12.9 247.93 L 13.57 247.25 L 12.55 245.46 L 11.15 245.39 L 10.93 242.26 L 10.51 241.06 L 10.15 239.59 L 11.15 239.12 L 10.88 238.55 L 8.47 238.34 L 8.61 237.12 L 11.28 234.83 L 10.89 234.37 L 9.1 235.21 L 8.51 234.77 L 8.23 233.33 L 8.7 232.21 Z",
      "position": {
        "x": 76.2,
        "y": 327.8
      },
      "badgeAnchor": {
        "x": 101.59,
        "y": 340.37
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "norman",
      "name": "Norman",
      "regionId": "northwest",
      "adjacencies": [
        "becker",
        "clay",
        "mahnomen",
        "polk"
      ],
      "shape": "M 44.03 363.24 L 146.87 364.35 L 146.27 431.5 L 129.47 431.73 L 44.9 430.62 L 44.83 430.51 L 44.72 430.23 L 44.81 429.89 L 44.95 429.85 L 46.36 429.83 L 45.77 428.72 L 46.97 428.44 L 46.78 427.1 L 45.8 426.13 L 45.8 425.78 L 46.69 424.46 L 45.44 424.27 L 45.44 424.04 L 46.12 423.47 L 45.79 422.68 L 45.04 422.33 L 44.29 422.77 L 44.85 421.26 L 46.06 421.01 L 45.28 419.58 L 45.37 419.36 L 45.23 417.36 L 43.91 417.64 L 44.15 416.75 L 45.63 416 L 44.38 414.94 L 44.53 414.78 L 45.96 414.66 L 44.27 413.35 L 44.45 413.01 L 45.38 412.52 L 45.51 411.89 L 44.51 410.95 L 44.51 410.78 L 44.92 409.7 L 43.77 409.11 L 44.03 408.83 L 44.88 408.76 L 45.28 408.15 L 43.77 407.52 L 44.11 407.09 L 44.78 405.98 L 44.57 405.16 L 44.31 403.73 L 44.79 402.6 L 45.45 401.35 L 44.43 399.99 L 44.64 398.23 L 45.42 398.01 L 46.17 396.65 L 44.6 396.11 L 44.86 395.66 L 45.84 395.26 L 46.05 394.56 L 45.11 394.23 L 44.74 393.52 L 44.36 392.19 L 45.4 392.12 L 45.61 391.41 L 43.89 390.61 L 43.89 390.16 L 43.38 388.89 L 43.47 388.63 L 45.28 388.28 L 45.07 387.74 L 43.68 387.67 L 43.84 387.41 L 44.5 387.01 L 44.08 386.24 L 44.34 386.07 L 45.32 386.05 L 45.42 384.64 L 44.39 383.67 L 44.45 383.46 L 45.35 383.02 L 44.45 381.79 L 44.45 381.53 L 44.6 380.27 L 43.16 380.41 L 42.57 379.75 L 41.56 378.99 L 41.94 378.55 L 43.07 377.99 L 42.64 377 L 42.79 376.83 L 43.58 376.46 L 42.72 375.4 L 42.84 375.14 L 43.09 374.08 L 43.07 372.65 L 43.42 372.37 L 42.58 371.64 L 42.67 371.33 L 43.47 370.51 L 42.79 369.43 L 42.81 369.17 L 42.84 368.54 L 44.01 367.36 L 43.42 366.94 L 42.48 367.45 L 41.92 367.24 L 42.18 366.53 L 43.84 365.97 L 42.51 365.05 L 42.84 364.56 L 44.15 363.93 Z",
      "position": {
        "x": 112.5,
        "y": 397.8
      },
      "badgeAnchor": {
        "x": 96.72,
        "y": 398.55
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "mahnomen",
      "name": "Mahnomen",
      "regionId": "northwest",
      "adjacencies": [
        "becker",
        "clearwater",
        "norman",
        "polk"
      ],
      "shape": "M 214.81 364.61 L 215.25 364.96 L 214.64 432.48 L 167.04 432.25 L 146.27 431.5 L 146.87 364.35 L 150.3 364.37 Z",
      "position": {
        "x": 180.8,
        "y": 398.4
      },
      "badgeAnchor": {
        "x": 179.68,
        "y": 397.95
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "clay",
      "name": "Clay",
      "regionId": "northwest",
      "adjacencies": [
        "becker",
        "norman",
        "otter-tail",
        "wilkin"
      ],
      "shape": "M 44.9 430.62 L 129.47 431.73 L 129.3 465.67 L 132.03 465.61 L 131.44 515.61 L 131.49 532.65 L 116.86 532.49 L 49.98 531.6 L 49.81 531.41 L 48.76 531.45 L 48.29 531.43 L 48.53 530.87 L 49.35 529.37 L 48.41 528.75 L 48.5 528.57 L 48.83 527.67 L 47.66 526.54 L 47.91 526.07 L 48.17 524.94 L 48.41 523.96 L 49.02 523.63 L 48.22 522.81 L 48.4 522.71 L 49.11 522.61 L 48.57 521.93 L 48.95 521.6 L 49.74 520.85 L 49.3 519.72 L 49.25 519.39 L 50 517.98 L 49.28 517.37 L 49.54 517.19 L 50.14 515.94 L 49.7 514.62 L 49.75 514.44 L 50.62 513.8 L 49.94 513.3 L 50.22 513.03 L 50.66 512.51 L 50.24 511.94 L 50.41 511.59 L 50.73 509.71 L 50.17 508.13 L 50.31 507 L 50.85 506.25 L 50.12 505.43 L 50.83 505.01 L 49.75 503.79 L 50.45 503.15 L 49.21 503.08 L 49.32 502.59 L 50.19 501.55 L 49.09 500.59 L 48.83 499.08 L 48.41 497.95 L 48.36 497.65 L 48.88 497.02 L 48.41 495.89 L 49.72 494 L 50.88 493.61 L 49.54 492.12 L 49.82 491.89 L 50.55 492.01 L 50.41 490.74 L 51.13 491.16 L 51.89 490.85 L 51.18 489.89 L 51.79 488.93 L 50.76 488.36 L 50.81 488.24 L 51.68 488.04 L 50.87 486.37 L 51.11 484.95 L 51.63 484.58 L 51.53 483.69 L 51.79 483.42 L 52.75 483.76 L 53.2 483.31 L 52.19 481.64 L 52.36 481.28 L 52.83 480.91 L 52.08 479.87 L 52.4 479.12 L 52.61 478.6 L 53.11 478.25 L 53.7 476.91 L 53.88 476.63 L 54.82 476.32 L 53.84 475.22 L 54.94 474.63 L 53.69 473.84 L 54.43 473.25 L 54.33 472.63 L 53.29 472.85 L 51.46 474.28 L 50.03 473.6 L 50.17 471.51 L 50.07 470.4 L 48.66 470.33 L 48.69 469.74 L 49.16 468.99 L 48.71 468.29 L 48.69 468.1 L 49.39 466.76 L 49.25 466.03 L 48.24 466.78 L 47.72 466.26 L 47.28 466.61 L 46.34 465.96 L 46.52 463.61 L 46.39 462.88 L 46.22 460.97 L 46.46 460.25 L 45.96 458.91 L 44.6 458.95 L 44.15 458.15 L 45.54 455.42 L 46.9 454.48 L 45.82 453.48 L 46.01 453.31 L 47.23 453.03 L 47.86 452.18 L 46.69 452.34 L 46.74 451.08 L 45.79 450.72 L 46.03 450.21 L 46.66 449.69 L 45.92 448.32 L 46.13 447.9 L 46.69 447.62 L 46.48 445.93 L 45.56 445.46 L 46.12 444.8 L 46.81 444.42 L 47.14 442.9 L 45.91 442.45 L 46.41 441.84 L 46.93 441.44 L 46.92 440.07 L 47 439.81 L 47.32 439.07 L 46.69 438.05 L 46.45 437.49 L 44.92 436.46 L 44.65 436.12 L 45.09 435.75 L 46.72 435.39 L 45.94 434.67 L 45.85 433.87 L 45.73 431.92 Z",
      "position": {
        "x": 92,
        "y": 491.5
      },
      "badgeAnchor": {
        "x": 92.21,
        "y": 489.61
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "becker",
      "name": "Becker",
      "regionId": "northwest",
      "adjacencies": [
        "clay",
        "clearwater",
        "hubbard",
        "mahnomen",
        "norman",
        "otter-tail",
        "wadena"
      ],
      "shape": "M 129.47 431.73 L 146.27 431.5 L 167.04 432.25 L 214.64 432.48 L 248.16 432.41 L 264.88 432.69 L 264.58 452.16 L 264.77 465.74 L 265.64 465.72 L 265.8 498.94 L 266.06 515.98 L 153.84 515.99 L 152.5 515.57 L 151.63 515.94 L 131.44 515.61 L 132.03 465.61 L 129.3 465.67 Z",
      "position": {
        "x": 173.9,
        "y": 474.1
      },
      "badgeAnchor": {
        "x": 199.11,
        "y": 471.8
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "beltrami",
      "name": "Beltrami",
      "regionId": "far-north",
      "adjacencies": [
        "cass",
        "clearwater",
        "hubbard",
        "itasca",
        "koochiching",
        "lake-of-the-woods",
        "marshall",
        "pennington",
        "roseau"
      ],
      "shape": "M 208.36 163.58 L 241.79 163.25 L 250.02 163.35 L 258.42 163.35 L 258.67 196.77 L 359.37 195.72 L 359.89 195.81 L 361.51 264.04 L 362.04 264.11 L 362.33 297.18 L 362.82 322.64 L 362.68 344.55 L 363.08 346.15 L 363.62 374.7 L 363.69 381.46 L 330.21 381.86 L 327.56 381.82 L 263.14 381.86 L 262.44 330.78 L 261.14 331.62 L 261.05 292.7 L 253.83 290.56 L 251.29 286.81 L 250.24 281.71 L 251.08 275.67 L 253.22 270.13 L 257.13 263.97 L 210.74 263.96 L 209.77 263.97 L 209.47 234.72 L 209.57 230.61 L 209.45 197.15 L 208.39 197.17 Z",
      "position": {
        "x": 308,
        "y": 249.9
      },
      "badgeAnchor": {
        "x": 307.87,
        "y": 248.64
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "clearwater",
      "name": "Clearwater",
      "regionId": "northwest",
      "adjacencies": [
        "becker",
        "beltrami",
        "hubbard",
        "mahnomen",
        "pennington",
        "polk"
      ],
      "shape": "M 210.74 263.96 L 257.13 263.97 L 253.22 270.13 L 251.08 275.67 L 250.24 281.71 L 251.29 286.81 L 253.83 290.56 L 261.05 292.7 L 261.14 331.62 L 262.44 330.78 L 263.14 381.86 L 263.05 398.95 L 264.81 399 L 264.88 432.69 L 248.16 432.41 L 214.64 432.48 L 215.25 364.96 L 214.81 364.61 L 214.52 331.51 L 211.18 331.39 L 210.81 281.06 Z",
      "position": {
        "x": 236.1,
        "y": 309.6
      },
      "badgeAnchor": {
        "x": 235.81,
        "y": 348.84
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "hubbard",
      "name": "Hubbard",
      "regionId": "northwest",
      "adjacencies": [
        "becker",
        "beltrami",
        "cass",
        "clearwater",
        "wadena"
      ],
      "shape": "M 263.14 381.86 L 327.56 381.82 L 330.21 381.86 L 330.4 398.84 L 331.46 398.89 L 331.93 465.63 L 333.08 465.61 L 332.83 499.1 L 316.09 498.92 L 304.21 498.92 L 265.8 498.94 L 265.64 465.72 L 264.77 465.74 L 264.88 432.69 L 264.81 399 L 263.05 398.95 Z",
      "position": {
        "x": 298.2,
        "y": 452.3
      },
      "badgeAnchor": {
        "x": 299.16,
        "y": 464.28
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "cass",
      "name": "Cass",
      "regionId": "north-central",
      "adjacencies": [
        "aitkin",
        "beltrami",
        "crow-wing",
        "hubbard",
        "itasca",
        "morrison",
        "todd",
        "wadena"
      ],
      "shape": "M 330.21 381.86 L 340.3 381.72 L 363.69 381.46 L 363.62 374.7 L 364.68 375.03 L 364.89 376.1 L 365.08 376.81 L 367.92 377.91 L 368.25 377.18 L 370.13 378.38 L 372.77 378.67 L 375.35 380.22 L 376.93 379.92 L 403.37 367.57 L 404.41 367.46 L 406.99 368.65 L 410.76 376.11 L 413.84 379.79 L 414.21 380.67 L 413.46 382.38 L 413.46 385.84 L 414.71 390.89 L 416.42 392.8 L 420.94 394.39 L 422.91 395.59 L 424.53 397.15 L 425.55 399.26 L 425.92 400.06 L 426.89 400.56 L 428.42 401.87 L 429.66 402.55 L 431.57 401.17 L 433.25 397.74 L 433.49 397.12 L 434.2 396.93 L 435.42 396.98 L 436.76 397.85 L 440.26 400.51 L 442.99 400.72 L 446.49 400.01 L 449.06 400.67 L 448.91 401.73 L 448.39 402.01 L 447.53 403.45 L 447.65 404.62 L 447.95 406.12 L 447.24 405.59 L 446.63 406.06 L 446.77 407.56 L 446.98 409.42 L 445.83 409.28 L 445.32 409.82 L 444.89 410.55 L 444.23 411.81 L 444.35 413.41 L 445.67 417.55 L 446.82 417.88 L 447.64 418.49 L 448.52 418.91 L 449.43 453.55 L 449.59 463.86 L 450.21 497.41 L 374.91 498.26 L 375.05 532.16 L 377.09 532.11 L 377.85 594.42 L 378.62 596.98 L 377.91 600.2 L 376.65 599.78 L 376.32 600.58 L 376.15 600.41 L 375.96 599.61 L 375.84 598.2 L 374.65 596.9 L 373.05 596.58 L 370.84 596.27 L 369.41 595.07 L 369.12 594.09 L 368.47 592.79 L 367.4 591.74 L 366.14 591.33 L 365.34 590.54 L 364 590.13 L 359.81 591.73 L 357.28 593.66 L 354.29 593.62 L 352.1 594.56 L 350.36 595.05 L 350.45 595.66 L 349.49 596.04 L 347.26 594.93 L 342.08 591.59 L 340.58 592.25 L 339.53 592.27 L 338.63 591.4 L 337.88 589.2 L 337.41 587.88 L 335.72 587.83 L 334.84 587.67 L 334.4 587.41 L 333.76 586.72 L 333.48 586.19 L 331.89 585.79 L 331.29 586.33 L 329.98 586.89 L 327.67 586.59 L 324.66 585.78 L 324.01 584.45 L 323.8 583.22 L 324.05 582.24 L 323.49 580.92 L 322.69 580.57 L 320.3 580.62 L 319.3 578.62 L 317.89 578.55 L 317.07 577.34 L 317.8 574.74 L 317 574.41 L 317.09 532.89 L 316.65 532.91 L 316.09 498.92 L 332.83 499.1 L 333.08 465.61 L 331.93 465.63 L 331.46 398.89 L 330.4 398.84 Z",
      "position": {
        "x": 388.4,
        "y": 441.9
      },
      "badgeAnchor": {
        "x": 382.02,
        "y": 453.72
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "crow-wing",
      "name": "Crow Wing",
      "regionId": "north-central",
      "adjacencies": [
        "aitkin",
        "cass",
        "mille-lacs",
        "morrison"
      ],
      "shape": "M 376.32 600.58 L 376.31 600.05 L 377.19 599.77 L 377.91 600.2 L 378.62 596.98 L 377.85 594.42 L 377.09 532.11 L 375.05 532.16 L 374.91 498.26 L 450.21 497.41 L 451 538.04 L 450.58 538.93 L 446.37 540.09 L 447.83 606.29 L 448.14 622.95 L 372.62 623.89 L 372.72 620.88 L 373.31 620.14 L 373.4 619.43 L 372.39 617.69 L 369.55 613.76 L 369.61 611.72 L 369.74 610.38 L 370.01 609.95 L 370.27 609.84 L 370.35 609.49 L 370.42 608.87 L 370.58 608.42 L 372.08 607.86 L 373.12 606.95 L 373.45 606.41 L 375 604.69 L 375.07 604.07 L 375.07 603.54 L 375.84 602.55 L 376.44 602.45 L 377.23 601.63 Z",
      "position": {
        "x": 412,
        "y": 532.9
      },
      "badgeAnchor": {
        "x": 411.54,
        "y": 534.96
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "aitkin",
      "name": "Aitkin",
      "regionId": "north-central",
      "adjacencies": [
        "carlton",
        "cass",
        "crow-wing",
        "itasca",
        "kanabec",
        "mille-lacs",
        "pine",
        "saint-louis"
      ],
      "shape": "M 449.43 453.55 L 474.31 452.77 L 544.18 451.95 L 545.45 502.11 L 545.73 520.12 L 546.39 535.62 L 547.37 535.69 L 548.48 569.37 L 548.78 581.51 L 549.51 589.12 L 550.19 619.76 L 525.65 619.94 L 499.56 621.99 L 499.06 604.54 L 447.83 606.29 L 446.37 540.09 L 450.58 538.93 L 451 538.04 L 450.21 497.41 L 449.59 463.86 Z",
      "position": {
        "x": 498.1,
        "y": 554.4
      },
      "badgeAnchor": {
        "x": 496.66,
        "y": 555.57
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "wadena",
      "name": "Wadena",
      "regionId": "north-central",
      "adjacencies": [
        "becker",
        "cass",
        "hubbard",
        "otter-tail",
        "todd"
      ],
      "shape": "M 265.8 498.94 L 304.21 498.92 L 316.09 498.92 L 316.65 532.91 L 317.09 532.89 L 317 574.41 L 317.8 574.74 L 317.07 577.34 L 317.89 578.55 L 319.3 578.62 L 320.3 580.62 L 323.49 580.92 L 324.05 582.24 L 323.8 583.22 L 267.19 583.36 L 267.21 533.15 L 266.15 533.1 L 266.06 515.98 Z",
      "position": {
        "x": 291.3,
        "y": 524.4
      },
      "badgeAnchor": {
        "x": 292.19,
        "y": 539.82
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "otter-tail",
      "name": "Otter Tail",
      "regionId": "north-central",
      "adjacencies": [
        "becker",
        "clay",
        "douglas",
        "grant",
        "todd",
        "wadena",
        "wilkin"
      ],
      "shape": "M 131.44 515.61 L 151.63 515.94 L 152.5 515.57 L 153.84 515.99 L 266.06 515.98 L 266.15 533.1 L 267.21 533.15 L 267.19 583.36 L 267.19 600.38 L 268.52 600.43 L 268.76 634.19 L 184.83 634.28 L 142.19 633.94 L 117.9 633.42 L 118.42 599.31 L 116.32 599.35 L 116.86 532.49 L 131.49 532.65 Z",
      "position": {
        "x": 185.2,
        "y": 575.2
      },
      "badgeAnchor": {
        "x": 185.39,
        "y": 576.78
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "mille-lacs",
      "name": "Mille Lacs",
      "regionId": "east-central",
      "adjacencies": [
        "aitkin",
        "benton",
        "crow-wing",
        "isanti",
        "kanabec",
        "morrison",
        "sherburne"
      ],
      "shape": "M 448.14 622.95 L 447.83 606.29 L 499.06 604.54 L 499.56 621.99 L 499.86 655.38 L 487.85 655.94 L 490.06 703.59 L 491.21 737.19 L 457.36 737.82 L 455.75 687.6 L 454.75 656.45 L 448.92 656.58 Z",
      "position": {
        "x": 474.1,
        "y": 634.4
      },
      "badgeAnchor": {
        "x": 474.66,
        "y": 631.61
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "kanabec",
      "name": "Kanabec",
      "regionId": "east-central",
      "adjacencies": [
        "aitkin",
        "isanti",
        "mille-lacs",
        "pine"
      ],
      "shape": "M 550.19 619.76 L 551.04 653.94 L 539.12 654.32 L 540.49 702.72 L 490.06 703.59 L 487.85 655.94 L 499.86 655.38 L 499.56 621.99 L 525.65 619.94 Z",
      "position": {
        "x": 514.3,
        "y": 676.3
      },
      "badgeAnchor": {
        "x": 517.9,
        "y": 664.35
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "pine",
      "name": "Pine",
      "regionId": "east-central",
      "adjacencies": [
        "aitkin",
        "carlton",
        "chisago",
        "kanabec"
      ],
      "shape": "M 548.48 569.37 L 650.58 566.11 L 651.17 580.31 L 653.12 633.2 L 649.87 634.12 L 647.95 635.51 L 647.36 636.14 L 646.37 639.6 L 646.87 641.2 L 645.53 644.25 L 644.4 645.34 L 640.33 644.47 L 638.87 643.5 L 636.85 643.06 L 633.84 644.82 L 633.23 646.25 L 633.16 647.05 L 632.47 647.61 L 631.84 649.22 L 630.9 650.09 L 630.73 651.64 L 630.57 652.16 L 629.07 652.98 L 626.69 652.81 L 625.78 652.03 L 624.37 651.8 L 623.92 651.56 L 622.34 651.5 L 621.83 651.66 L 621.22 651.99 L 619.73 653.35 L 618.98 654.78 L 618.91 655.75 L 619.14 657.35 L 618.7 657.8 L 617.03 657.94 L 614.05 659.58 L 612.21 659.89 L 611.77 660.22 L 608.89 661.7 L 607.56 661.88 L 607.01 663.23 L 605.46 663.35 L 604.55 663.82 L 602.85 665.15 L 602.41 666.54 L 601.96 667.29 L 598.17 669.67 L 596.76 671.24 L 596.03 672.28 L 594.96 674.53 L 594.2 678.84 L 591.83 681.07 L 591.08 682.01 L 591.62 684.06 L 592.35 685.44 L 592.14 686.73 L 590 689.35 L 588.49 695.29 L 586.45 697.72 L 582.78 701.33 L 576.17 701.55 L 540.49 702.72 L 539.12 654.32 L 551.04 653.94 L 550.19 619.76 L 549.51 589.12 L 548.78 581.51 Z",
      "position": {
        "x": 596.2,
        "y": 613.6
      },
      "badgeAnchor": {
        "x": 594.12,
        "y": 629.22
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "morrison",
      "name": "Morrison",
      "regionId": "west-central",
      "adjacencies": [
        "benton",
        "cass",
        "crow-wing",
        "mille-lacs",
        "stearns",
        "todd"
      ],
      "shape": "M 376.32 600.58 L 376.86 601.02 L 377.05 601.98 L 375.84 602.55 L 375.49 602.9 L 375.07 604.07 L 375 604.69 L 374.41 605.32 L 373.36 606.68 L 372.6 607.58 L 371.64 608.05 L 370.58 608.42 L 370.35 609.49 L 370.27 609.84 L 370.01 609.95 L 369.74 610.38 L 369.61 611.72 L 369.54 613.04 L 369.83 614.11 L 373.02 618.74 L 373.31 620.14 L 372.72 620.88 L 372.93 622.11 L 372.62 623.89 L 448.14 622.95 L 448.92 656.58 L 454.75 656.45 L 455.75 687.6 L 433.92 687.75 L 416.87 687.18 L 376.34 688.45 L 376.55 689.49 L 379.35 692.54 L 381.75 693.09 L 382.33 694.94 L 383.14 695.9 L 386.35 697.15 L 336.89 697.98 L 336.84 667.62 L 336.05 667.64 L 335.55 599.8 L 334.84 599.82 L 334.84 587.67 L 334.94 587.76 L 336.09 587.83 L 337.41 587.88 L 338.07 590.44 L 339.17 592.01 L 339.97 592.35 L 341.29 591.97 L 342.08 591.59 L 343.14 592.11 L 347.97 595.54 L 349.49 596.04 L 350.45 595.66 L 350.27 595.4 L 350.79 594.77 L 352.81 594.37 L 354.29 593.62 L 357.28 593.66 L 359.81 591.73 L 364 590.13 L 365.88 591.07 L 367.4 591.74 L 369.03 594.01 L 369.41 595.07 L 370.84 596.27 L 374.3 596.72 L 375.64 597.59 L 375.96 599.61 L 376.15 600.41 Z",
      "position": {
        "x": 369,
        "y": 656.5
      },
      "badgeAnchor": {
        "x": 395.11,
        "y": 655.46
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "todd",
      "name": "Todd",
      "regionId": "west-central",
      "adjacencies": [
        "cass",
        "douglas",
        "morrison",
        "otter-tail",
        "stearns",
        "wadena"
      ],
      "shape": "M 267.19 583.36 L 323.8 583.22 L 323.82 583.39 L 324.66 585.78 L 329.98 586.89 L 331.89 585.79 L 333.48 586.19 L 333.76 586.72 L 334.4 587.41 L 334.84 587.67 L 334.84 599.82 L 335.55 599.8 L 336.05 667.64 L 336.84 667.62 L 336.89 697.98 L 269.75 698.7 L 269.73 668.09 L 268.67 668.11 L 268.76 634.19 L 268.52 600.43 L 267.19 600.38 Z",
      "position": {
        "x": 302.3,
        "y": 659.7
      },
      "badgeAnchor": {
        "x": 303.13,
        "y": 659.65
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "stearns",
      "name": "Stearns",
      "regionId": "west-central",
      "adjacencies": [
        "benton",
        "douglas",
        "kandiyohi",
        "meeker",
        "morrison",
        "pope",
        "sherburne",
        "todd",
        "wright"
      ],
      "shape": "M 336.89 697.98 L 386.35 697.15 L 386.61 697.32 L 387.62 698.37 L 389.23 703.55 L 390.94 705.36 L 395.33 707.49 L 395.34 708.37 L 394.49 709.54 L 396.51 712.5 L 397.21 716.12 L 398.01 716.54 L 399.42 716.41 L 398.13 718.31 L 397.33 721.95 L 397.55 727.95 L 399.05 731.29 L 401.66 733.43 L 402.7 737.04 L 404.71 739.04 L 405.26 740.08 L 404.84 745.04 L 405.94 746.95 L 405.65 749.62 L 406.41 752.09 L 411.2 756.3 L 411.61 759.12 L 412.35 760.16 L 414.4 760.91 L 414.87 762.49 L 415.84 762.56 L 416.85 763.61 L 418.33 763.12 L 418.89 764.27 L 418.21 765.16 L 416.66 767.05 L 416 769.46 L 413.96 772.95 L 414.02 775.08 L 413.77 776.14 L 412.85 778.63 L 412.8 779.6 L 412.1 780.33 L 411.21 780.44 L 410.27 781.97 L 403.64 788.96 L 401.87 788.96 L 401.43 787.45 L 401.28 787.12 L 400.74 786.25 L 400.01 785.73 L 396.86 786.01 L 395 787.12 L 391.43 787.69 L 390.47 788.25 L 390.91 789.35 L 389.98 789.83 L 389.98 792.41 L 373.54 792.77 L 373.43 784.39 L 321.7 784.89 L 321.24 768.12 L 271.02 768.64 L 270.95 735.23 L 270.06 735.05 L 269.89 701.45 L 269.75 698.7 Z",
      "position": {
        "x": 355.8,
        "y": 741.1
      },
      "badgeAnchor": {
        "x": 355.97,
        "y": 740.48
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "benton",
      "name": "Benton",
      "regionId": "west-central",
      "adjacencies": [
        "mille-lacs",
        "morrison",
        "sherburne",
        "stearns"
      ],
      "shape": "M 386.35 697.15 L 386.09 696.99 L 383.14 695.9 L 382.33 694.94 L 381.75 693.09 L 379.35 692.54 L 376.55 689.49 L 376.34 688.45 L 416.87 687.18 L 433.92 687.75 L 455.75 687.6 L 457.36 737.82 L 424.77 738.74 L 404.71 739.04 L 404.53 738.95 L 402.7 737.04 L 401.66 733.43 L 399.05 731.29 L 397.55 727.95 L 397.33 721.95 L 398.13 718.31 L 399.42 716.41 L 398.01 716.54 L 397.21 716.12 L 396.51 712.5 L 394.49 709.54 L 395.34 708.37 L 395.13 707.14 L 390.94 705.36 L 389.23 703.55 L 387.62 698.37 Z",
      "position": {
        "x": 424.5,
        "y": 713
      },
      "badgeAnchor": {
        "x": 425.71,
        "y": 712.3
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "sherburne",
      "name": "Sherburne",
      "regionId": "west-central",
      "adjacencies": [
        "anoka",
        "benton",
        "hennepin",
        "isanti",
        "mille-lacs",
        "stearns",
        "wright"
      ],
      "shape": "M 491.21 737.19 L 492.06 764.93 L 492.22 798 L 491.96 797.91 L 491.16 797.75 L 490.6 796.88 L 490.32 796.36 L 488.91 796.13 L 488.01 795.35 L 486.72 793.52 L 486.5 790.96 L 485.83 789.66 L 484.91 787.92 L 484.13 788.37 L 483.96 789 L 483.43 789.1 L 480.79 789.15 L 475.83 788.93 L 474.66 788.42 L 471.04 788.69 L 469.42 788.02 L 469.25 787.66 L 468.52 786.98 L 467.21 787.97 L 467.04 788.08 L 465.89 788.27 L 465.46 788.55 L 464.76 788.74 L 463.68 788.15 L 462.97 787.73 L 462.69 787.73 L 462.17 787.57 L 461.28 787.76 L 459.8 788.6 L 457.59 788.48 L 452.02 785.5 L 448.58 781.6 L 447.24 781.03 L 444.57 780.82 L 441.08 778.7 L 440.8 777.98 L 440.33 776.76 L 439.32 775.63 L 437.63 774.71 L 437.25 773.48 L 436.33 772.43 L 435.61 772.01 L 434.72 772.12 L 434.38 772.31 L 432.71 772.26 L 432.1 772.8 L 431.66 773.42 L 431.05 773.61 L 429.33 771.89 L 428.62 771.37 L 427.89 770.69 L 427.61 770.26 L 426.53 769.13 L 425.38 769.33 L 424.49 769.18 L 424.32 769.09 L 423.06 769.04 L 421.72 768.27 L 420.18 766.36 L 418.89 764.27 L 418.61 763.64 L 418.07 763.05 L 416.85 763.61 L 415.84 762.56 L 414.87 762.49 L 414.4 760.91 L 412.35 760.16 L 411.61 759.12 L 411.2 756.3 L 406.41 752.09 L 405.65 749.62 L 405.94 746.95 L 404.84 745.04 L 405.26 740.08 L 404.71 739.04 L 422.73 738.53 L 457.36 737.82 Z",
      "position": {
        "x": 465,
        "y": 762.5
      },
      "badgeAnchor": {
        "x": 466.24,
        "y": 762.84
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "isanti",
      "name": "Isanti",
      "regionId": "east-central",
      "adjacencies": [
        "anoka",
        "chisago",
        "kanabec",
        "mille-lacs",
        "sherburne"
      ],
      "shape": "M 490.06 703.59 L 540.49 702.72 L 541.68 735.78 L 557.58 735.82 L 558.91 763.73 L 543.87 763.77 L 492.06 764.93 L 491.21 737.19 Z",
      "position": {
        "x": 516.7,
        "y": 739
      },
      "badgeAnchor": {
        "x": 516.95,
        "y": 738.69
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "chisago",
      "name": "Chisago",
      "regionId": "east-central",
      "adjacencies": [
        "anoka",
        "isanti",
        "pine",
        "washington"
      ],
      "shape": "M 540.49 702.72 L 570.97 701.78 L 582.78 701.33 L 582.43 701.52 L 579.11 703.15 L 578.17 703.78 L 577.75 705.33 L 576.85 714.12 L 575.66 719.72 L 576.24 724.92 L 576.01 727.59 L 576.15 728.37 L 576.62 729.5 L 576.47 730.84 L 576.67 731.99 L 578.74 733.26 L 581.58 733.36 L 585.83 734.46 L 590.14 732.79 L 591.47 732.75 L 594.51 734.44 L 597.59 737.12 L 598.31 738.88 L 598.06 742.24 L 598.84 743.53 L 601.72 746.83 L 604.33 751.62 L 606.5 753.18 L 607.39 753.45 L 608.45 754.26 L 609.56 756.09 L 609.53 759.66 L 609.51 760.6 L 609.83 762.9 L 609.34 764.67 L 605.14 770.26 L 602.88 772.27 L 602.38 773.41 L 602.92 777.62 L 602.36 779.17 L 600.76 781.78 L 597.05 785.14 L 559.53 785.92 L 558.91 763.73 L 557.58 735.82 L 541.68 735.78 Z",
      "position": {
        "x": 582.3,
        "y": 761.1
      },
      "badgeAnchor": {
        "x": 582.74,
        "y": 760.81
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "wilkin",
      "name": "Wilkin",
      "regionId": "bois-de-sioux",
      "adjacencies": [
        "clay",
        "grant",
        "otter-tail",
        "traverse"
      ],
      "shape": "M 49.98 531.6 L 116.86 532.49 L 116.32 599.35 L 118.42 599.31 L 117.9 633.42 L 117.87 650.16 L 75.98 649.57 L 75.91 649.35 L 76.05 647.73 L 78.1 643.64 L 79.01 639.9 L 78.07 631.68 L 77.02 627.18 L 76.08 625.4 L 76.45 621.17 L 76.19 620.02 L 75.02 619.5 L 74.92 617.66 L 75.6 616.4 L 74.71 616.06 L 74.79 615.97 L 75.28 613.65 L 74.46 613.15 L 73.52 609.43 L 73.84 606.92 L 75.49 605.94 L 75.32 605.51 L 74.17 605.35 L 73.98 604.81 L 74.06 604.55 L 73.85 603.54 L 73.12 601.65 L 73.47 601.19 L 73.96 598.97 L 73.33 598.53 L 73.42 598.36 L 74.03 597.73 L 72.95 597.03 L 73.72 596.51 L 73.16 595.52 L 73.73 594.74 L 73.87 593.78 L 73.72 591.64 L 72.98 590.61 L 73 590.44 L 73.4 590.16 L 73.18 589.76 L 71.66 588.65 L 71.3 588.02 L 71.19 586.78 L 69.77 585.74 L 68.53 585.95 L 67.61 585.62 L 67.59 584.45 L 67.69 583.65 L 66.89 582.87 L 65.08 580.96 L 64.53 579.28 L 64.75 578.34 L 63.9 577.96 L 63.15 575.42 L 62.42 574.88 L 62.25 574.45 L 62.14 574.01 L 61.17 573.8 L 61.17 573.49 L 61.33 572.43 L 59.92 572.62 L 60 572.18 L 60.47 571.19 L 59.71 570.41 L 59.86 569.26 L 58.4 569.37 L 58.07 568.39 L 58.78 568.3 L 57.88 567.16 L 57.97 566.79 L 58.7 566.56 L 58.49 565.57 L 59.08 565.01 L 58.49 563.4 L 57.57 563.54 L 57.55 563.27 L 58.51 562.54 L 55.93 561.08 L 55.91 560.46 L 55.55 559.72 L 55.72 559.22 L 56.33 559.03 L 56.23 557.79 L 55.27 556.85 L 55.51 556.31 L 56.45 555.98 L 55.55 554.8 L 55.55 554.61 L 56.17 554.52 L 55.18 553.11 L 55.08 552.71 L 55.69 552.12 L 54.97 551.25 L 54.85 550 L 55.46 549.65 L 54.38 548.43 L 54.47 547.89 L 55.25 547.35 L 54.26 545.59 L 54.31 545.18 L 54.94 543.98 L 54.24 542.7 L 54.45 542.13 L 53.58 542.15 L 53.58 541.96 L 54.17 541.24 L 53.11 540.83 L 53.29 540.72 L 54 540.18 L 52.89 539.68 L 53.27 537.94 L 52.64 537.61 L 51.21 538.01 L 51.3 537.4 L 51.63 536.32 L 50.83 535.88 L 50.9 535.76 L 51.16 534.82 L 50.36 534.56 L 50.36 534.39 L 51.15 533.67 L 49.56 533.78 L 49.46 533.43 L 50.47 532.98 L 49.21 532.54 L 49.4 532.37 Z",
      "position": {
        "x": 88,
        "y": 561
      },
      "badgeAnchor": {
        "x": 93.84,
        "y": 586.77
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "grant",
      "name": "Grant",
      "regionId": "west",
      "adjacencies": [
        "douglas",
        "otter-tail",
        "stevens",
        "traverse",
        "wilkin"
      ],
      "shape": "M 117.9 633.42 L 142.19 633.94 L 184.83 634.28 L 184.78 667.76 L 186.01 667.83 L 185.87 701.47 L 118.87 700.79 L 119.05 666.97 L 117.73 666.99 L 117.87 650.16 Z",
      "position": {
        "x": 151.9,
        "y": 668.1
      },
      "badgeAnchor": {
        "x": 152.46,
        "y": 668.69
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "traverse",
      "name": "Traverse",
      "regionId": "bois-de-sioux",
      "adjacencies": [
        "big-stone",
        "grant",
        "stevens",
        "wilkin"
      ],
      "shape": "M 75.98 649.57 L 117.87 650.16 L 117.73 666.99 L 119.05 666.97 L 118.87 700.79 L 118.61 734.58 L 39.49 733.52 L 39.21 733.17 L 37.31 730.11 L 37.12 728.77 L 38.04 723.71 L 40.53 719.84 L 47.47 716.07 L 54.12 709.61 L 62.87 705.05 L 65.38 701.78 L 67.9 695.86 L 71.91 692 L 72.9 690.59 L 75.04 686.95 L 77.35 672.51 L 77.37 672.37 L 77.35 667.72 L 78.29 664.43 L 78.01 663.56 L 76.47 655.8 L 76.24 650.44 Z",
      "position": {
        "x": 92.6,
        "y": 708
      },
      "badgeAnchor": {
        "x": 96.61,
        "y": 696.62
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "big-stone",
      "name": "Big Stone",
      "regionId": "bois-de-sioux",
      "adjacencies": [
        "lac-qui-parle",
        "stevens",
        "swift",
        "traverse"
      ],
      "shape": "M 39.49 733.52 L 118.61 734.58 L 120.13 734.55 L 119.95 767.98 L 136.66 768.2 L 136.5 801.53 L 138.45 801.58 L 138.19 811.46 L 138.14 813.33 L 137.06 812.56 L 135.18 811.45 L 133.3 810.51 L 132.26 811.13 L 127.07 808.77 L 124.86 808.45 L 123.22 806 L 122.15 805.23 L 115.76 804.9 L 114.7 804.49 L 114.32 803.25 L 113.11 800.45 L 111.97 799.86 L 103.51 797.98 L 96.7 798.01 L 94.2 795.56 L 90.67 795.51 L 90.74 788.16 L 88.98 786.13 L 87.34 780.45 L 85.31 777.43 L 83.79 776.02 L 76.69 772.94 L 69.87 768.15 L 68.56 768.03 L 60.98 767.61 L 58.38 765.37 L 53.29 758.25 L 51.21 753.48 L 50.41 749.63 L 49.06 746.64 Z",
      "position": {
        "x": 96.9,
        "y": 757.3
      },
      "badgeAnchor": {
        "x": 96.7,
        "y": 757.21
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "stevens",
      "name": "Stevens",
      "regionId": "west",
      "adjacencies": [
        "big-stone",
        "grant",
        "pope",
        "swift",
        "traverse"
      ],
      "shape": "M 118.87 700.79 L 185.87 701.47 L 185.99 735.24 L 187.23 735.31 L 187.53 768.72 L 136.66 768.2 L 119.95 767.98 L 120.13 734.55 L 118.61 734.58 Z",
      "position": {
        "x": 153.1,
        "y": 734.8
      },
      "badgeAnchor": {
        "x": 152.46,
        "y": 733.89
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "pope",
      "name": "Pope",
      "regionId": "west",
      "adjacencies": [
        "douglas",
        "kandiyohi",
        "stearns",
        "stevens",
        "swift"
      ],
      "shape": "M 185.87 701.47 L 269.89 701.45 L 270.06 735.05 L 270.95 735.23 L 271.02 768.64 L 254.32 768.81 L 187.53 768.72 L 187.23 735.31 L 185.99 735.24 Z",
      "position": {
        "x": 228.4,
        "y": 735.1
      },
      "badgeAnchor": {
        "x": 227.89,
        "y": 733.89
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "douglas",
      "name": "Douglas",
      "regionId": "west",
      "adjacencies": [
        "grant",
        "otter-tail",
        "pope",
        "stearns",
        "todd"
      ],
      "shape": "M 184.83 634.28 L 268.76 634.19 L 268.67 668.11 L 269.73 668.09 L 269.75 698.7 L 269.89 701.45 L 185.87 701.47 L 186.01 667.83 L 184.78 667.76 Z",
      "position": {
        "x": 227.3,
        "y": 667.8
      },
      "badgeAnchor": {
        "x": 227.89,
        "y": 668.69
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "swift",
      "name": "Swift",
      "regionId": "west",
      "adjacencies": [
        "big-stone",
        "chippewa",
        "kandiyohi",
        "lac-qui-parle",
        "pope",
        "stevens"
      ],
      "shape": "M 136.66 768.2 L 187.53 768.72 L 254.32 768.81 L 254.39 802.49 L 255.45 802.45 L 255.69 818.79 L 148.06 818.7 L 147.36 818.72 L 147 818.46 L 139.95 815.24 L 138.14 813.33 L 138.12 812.89 L 138.45 801.58 L 136.5 801.53 Z",
      "position": {
        "x": 191.91,
        "y": 795.47
      },
      "badgeAnchor": {
        "x": 191.91,
        "y": 795.47
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "chippewa",
      "name": "Chippewa",
      "regionId": "west",
      "adjacencies": [
        "kandiyohi",
        "lac-qui-parle",
        "renville",
        "swift",
        "yellow-medicine"
      ],
      "shape": "M 147.36 818.72 L 148.06 818.7 L 255.69 818.79 L 255.57 869.31 L 223.34 869.61 L 223.71 896.27 L 222.82 896.28 L 222.26 895.15 L 222.42 893.99 L 220.61 892.35 L 219.67 893.69 L 218.85 892.56 L 217.35 893.03 L 216.99 892.7 L 217.51 892.25 L 217.82 890.56 L 220.22 890.51 L 221.27 889.86 L 217.84 886.94 L 215.72 886.71 L 215.27 886.28 L 216.05 885.48 L 216.29 884.22 L 212.25 882.45 L 211.87 880.6 L 211.05 879.56 L 208.22 879.18 L 208.03 878.39 L 206.95 877.52 L 205.35 877.38 L 205.5 876.41 L 204.95 875.02 L 202.7 873.82 L 202.14 872.51 L 200.44 871.12 L 200.77 870.41 L 197.71 868 L 197.78 867.03 L 196.35 866.26 L 195.22 867.43 L 190.15 866.47 L 191.11 865.74 L 190.9 863.64 L 189.61 861.64 L 188.36 860.68 L 187.28 859.72 L 186.57 859.22 L 185.59 859.67 L 184.6 858.73 L 183.38 859.46 L 182.2 858.5 L 180.36 858.62 L 179.17 857.68 L 178.53 856.28 L 176.55 854.38 L 176.56 850.85 L 174.47 848.32 L 172.16 847.49 L 169.88 843.99 L 158.17 833.27 L 149.92 823.09 Z",
      "position": {
        "x": 213,
        "y": 845.2
      },
      "badgeAnchor": {
        "x": 209.99,
        "y": 844.16
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "lac-qui-parle",
      "name": "Lac qui Parle",
      "regionId": "west",
      "adjacencies": [
        "big-stone",
        "chippewa",
        "swift",
        "yellow-medicine"
      ],
      "shape": "M 138.14 813.33 L 139.95 815.24 L 147.36 818.72 L 148.55 821.17 L 158.17 833.27 L 169.88 843.99 L 172.16 847.49 L 174.47 848.32 L 176.56 850.85 L 176.55 854.38 L 178.53 856.28 L 179.17 857.68 L 180.36 858.62 L 182.2 858.5 L 183.38 859.46 L 184.6 858.73 L 185.59 859.67 L 186.57 859.22 L 188.36 860.68 L 188.17 869.33 L 173.29 869.27 L 173 885.96 L 89.53 885.22 L 89.99 851.73 L 90.67 795.54 L 94.2 795.56 L 95.99 797.49 L 96.7 798.01 L 97.59 797.82 L 103.51 797.98 L 112.66 800.1 L 113.48 801.15 L 114.7 804.49 L 117.27 805.15 L 122.15 805.23 L 123.22 806 L 124.86 808.45 L 127.07 808.77 L 132.26 811.13 L 133.3 810.51 L 137.06 812.56 Z",
      "position": {
        "x": 125.6,
        "y": 849.9
      },
      "badgeAnchor": {
        "x": 125.05,
        "y": 850.64
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "yellow-medicine",
      "name": "Yellow Medicine",
      "regionId": "west",
      "adjacencies": [
        "chippewa",
        "lac-qui-parle",
        "lincoln",
        "lyon",
        "redwood",
        "renville"
      ],
      "shape": "M 89.53 885.22 L 173 885.96 L 173.29 869.27 L 188.17 869.33 L 188.36 860.68 L 189.61 861.64 L 190.9 863.64 L 191.11 865.74 L 190.15 866.47 L 195.22 867.43 L 196.35 866.26 L 197.78 867.03 L 197.71 868 L 200.77 870.41 L 200.44 871.12 L 202.14 872.51 L 202.7 873.82 L 204.95 875.02 L 205.5 876.41 L 205.35 877.38 L 206.95 877.52 L 208.03 878.39 L 208.22 879.18 L 211.05 879.56 L 211.87 880.6 L 212.25 882.45 L 216.29 884.22 L 216.05 885.48 L 215.27 886.28 L 215.72 886.71 L 217.84 886.94 L 221.27 889.86 L 220.22 890.51 L 217.82 890.56 L 217.51 892.25 L 216.99 892.7 L 217.35 893.03 L 218.85 892.56 L 219.67 893.69 L 220.61 892.35 L 222.42 893.99 L 222.26 895.15 L 222.82 896.28 L 223.71 896.27 L 224.31 895.81 L 224.94 896.06 L 225.58 896.93 L 226.28 897.1 L 226.92 898.23 L 227.39 898.75 L 228.8 898.37 L 229.41 898.09 L 230.49 898.68 L 231.55 899.02 L 231.92 899.71 L 232.28 900.32 L 233.89 900.48 L 234.7 901.07 L 235.26 902.57 L 235.1 903.37 L 237.24 904.2 L 237.59 904.18 L 237.78 904.64 L 237.8 905.77 L 239.49 906.18 L 240.31 906.69 L 240.57 936.78 L 207.76 936.81 L 206.53 936.83 L 206.63 919.9 L 139.1 919.51 L 89.12 918.85 Z",
      "position": {
        "x": 193.1,
        "y": 896.9
      },
      "badgeAnchor": {
        "x": 195.61,
        "y": 897.57
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "kandiyohi",
      "name": "Kandiyohi",
      "regionId": "west",
      "adjacencies": [
        "chippewa",
        "meeker",
        "pope",
        "renville",
        "stearns",
        "swift"
      ],
      "shape": "M 254.32 768.81 L 271.02 768.64 L 321.24 768.12 L 321.7 784.89 L 321.71 801.95 L 322.32 802.03 L 322.79 868.87 L 255.57 869.31 L 255.69 818.79 L 255.45 802.45 L 254.39 802.49 Z",
      "position": {
        "x": 289.1,
        "y": 835
      },
      "badgeAnchor": {
        "x": 289.62,
        "y": 836.11
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "lincoln",
      "name": "Lincoln",
      "regionId": "southwest",
      "adjacencies": [
        "lyon",
        "pipestone",
        "yellow-medicine"
      ],
      "shape": "M 89.12 918.85 L 139.1 919.51 L 138.7 936.01 L 141.27 936.06 L 140.16 1003.01 L 87.99 1002.65 L 88.89 935.72 Z",
      "position": {
        "x": 114.8,
        "y": 951.9
      },
      "badgeAnchor": {
        "x": 112.66,
        "y": 963.25
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "lyon",
      "name": "Lyon",
      "regionId": "southwest",
      "adjacencies": [
        "lincoln",
        "murray",
        "pipestone",
        "redwood",
        "yellow-medicine"
      ],
      "shape": "M 139.1 919.51 L 206.63 919.9 L 206.53 936.83 L 207.76 936.81 L 207.87 1003.92 L 142.37 1003.13 L 140.16 1003.01 L 141.27 936.06 L 138.7 936.01 Z",
      "position": {
        "x": 174.2,
        "y": 969.9
      },
      "badgeAnchor": {
        "x": 174.37,
        "y": 958.7
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "redwood",
      "name": "Redwood",
      "regionId": "southwest",
      "adjacencies": [
        "brown",
        "cottonwood",
        "lyon",
        "murray",
        "renville",
        "yellow-medicine"
      ],
      "shape": "M 207.76 936.81 L 240.57 936.78 L 240.31 906.69 L 241.02 906.95 L 246.8 908.06 L 247.3 911.06 L 248.59 912.8 L 250.92 914.33 L 253.93 914.19 L 255.5 913.01 L 256.39 912.99 L 259.28 915.67 L 260.02 917.24 L 261 917.22 L 262.81 919.03 L 264.72 921.64 L 268.1 922.37 L 272.08 926.51 L 273.34 926.49 L 274.33 927.71 L 275.67 928.2 L 276.59 929.78 L 277.57 930.03 L 276.97 930.91 L 278.31 931.59 L 279.64 931.04 L 284.04 934.38 L 285.73 934.43 L 286.91 935.73 L 287.69 935.28 L 288.53 937.11 L 291.26 936.43 L 293.68 937.53 L 293.78 938.15 L 294.76 937.94 L 295.47 938.81 L 298.26 940.08 L 299.14 939.98 L 301.21 941.7 L 304.23 941.55 L 305.2 941.79 L 305.67 942.49 L 306.73 942.47 L 307.84 945.08 L 309.01 945.41 L 309.1 986.95 L 275.56 987.12 L 275.48 1003.78 L 225.79 1003.81 L 207.87 1003.92 Z",
      "position": {
        "x": 246.3,
        "y": 969.9
      },
      "badgeAnchor": {
        "x": 247.35,
        "y": 968.98
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "renville",
      "name": "Renville",
      "regionId": "southwest",
      "adjacencies": [
        "brown",
        "chippewa",
        "kandiyohi",
        "mcleod",
        "meeker",
        "nicollet",
        "redwood",
        "sibley",
        "yellow-medicine"
      ],
      "shape": "M 322.79 868.87 L 358.38 868.28 L 359.01 868.35 L 359.3 902.08 L 341.05 902.29 L 342.6 953.07 L 318.84 953.14 L 318.27 951.83 L 316.93 950.89 L 315.36 948.19 L 312.6 947.55 L 312.23 946.49 L 311.08 946.96 L 309.01 945.41 L 307.84 945.08 L 306.73 942.47 L 305.67 942.49 L 305.2 941.79 L 304.23 941.55 L 301.21 941.7 L 299.14 939.98 L 298.26 940.08 L 295.47 938.81 L 294.76 937.94 L 293.78 938.15 L 293.68 937.53 L 291.26 936.43 L 288.53 937.11 L 287.69 935.28 L 286.91 935.73 L 285.73 934.43 L 284.04 934.38 L 279.64 931.04 L 278.31 931.59 L 276.97 930.91 L 277.57 930.03 L 276.59 929.78 L 275.67 928.2 L 274.33 927.71 L 273.34 926.49 L 272.08 926.51 L 268.1 922.37 L 264.72 921.64 L 262.81 919.03 L 261 917.22 L 260.02 917.24 L 259.28 915.67 L 256.39 912.99 L 255.5 913.01 L 253.93 914.19 L 250.92 914.33 L 248.59 912.8 L 247.3 911.06 L 246.8 908.06 L 240.31 906.69 L 239.49 906.18 L 238.6 906.03 L 237.8 905.77 L 237.7 905.16 L 237.59 904.18 L 237.24 904.2 L 236.62 904.03 L 235.1 903.37 L 235.26 902.57 L 235.24 901.76 L 233.89 900.48 L 233.09 900.41 L 232.28 900.32 L 231.92 899.71 L 231.55 899.02 L 230.49 898.68 L 229.41 898.09 L 228.8 898.37 L 227.39 898.75 L 226.28 897.1 L 224.94 896.06 L 224.31 895.81 L 223.71 896.27 L 223.34 869.61 L 255.57 869.31 Z",
      "position": {
        "x": 296.33,
        "y": 902.72
      },
      "badgeAnchor": {
        "x": 296.33,
        "y": 902.72
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "pipestone",
      "name": "Pipestone",
      "regionId": "southwest",
      "adjacencies": [
        "lincoln",
        "lyon",
        "murray",
        "rock"
      ],
      "shape": "M 142.37 1003.13 L 141.45 1070.03 L 87.2 1069.7 L 87.99 1002.65 L 140.16 1003.01 Z",
      "position": {
        "x": 114.7,
        "y": 1036.3
      },
      "badgeAnchor": {
        "x": 115.46,
        "y": 1041.6
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "murray",
      "name": "Murray",
      "regionId": "southwest",
      "adjacencies": [
        "cottonwood",
        "lyon",
        "nobles",
        "pipestone",
        "redwood",
        "rock"
      ],
      "shape": "M 207.87 1003.92 L 225.79 1003.81 L 225.9 1070.77 L 143.22 1070.08 L 141.45 1070.03 L 142.37 1003.13 Z",
      "position": {
        "x": 190.2,
        "y": 1037.1
      },
      "badgeAnchor": {
        "x": 193.57,
        "y": 1041.6
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "cottonwood",
      "name": "Cottonwood",
      "regionId": "southwest",
      "adjacencies": [
        "brown",
        "jackson",
        "murray",
        "nobles",
        "redwood",
        "watonwan"
      ],
      "shape": "M 225.79 1003.81 L 275.48 1003.78 L 276.45 1003.85 L 275.82 1020.78 L 310.07 1020.5 L 309.99 1070.72 L 268.17 1070.72 L 227.24 1070.84 L 225.9 1070.77 Z",
      "position": {
        "x": 255.3,
        "y": 1041.4
      },
      "badgeAnchor": {
        "x": 263.16,
        "y": 1041.6
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "brown",
      "name": "Brown",
      "regionId": "southwest",
      "adjacencies": [
        "blue-earth",
        "cottonwood",
        "nicollet",
        "redwood",
        "renville",
        "watonwan"
      ],
      "shape": "M 309.01 945.41 L 310.52 946.26 L 311.08 946.96 L 312.23 946.49 L 312.6 947.55 L 313.76 948.05 L 315.36 948.19 L 318.84 953.14 L 319.92 954.09 L 322.97 955.87 L 324.03 955.24 L 325.53 955.21 L 328.5 957.52 L 331.72 958.43 L 332.52 958.84 L 332.54 959.73 L 331.77 960.62 L 331.79 961.33 L 332.76 961.66 L 333.83 961.56 L 333.76 962.34 L 333.77 963.14 L 334.66 962.95 L 335.55 962.93 L 336.09 964.06 L 335.76 964.86 L 336.38 965.37 L 337.53 964.92 L 338.42 964.71 L 339.33 965.67 L 340.56 965.11 L 342.35 966.4 L 342.48 967.54 L 345.64 967.02 L 346.46 967.18 L 346.91 968.33 L 348.62 968.73 L 349.51 969.23 L 351.73 969.2 L 352.43 969.09 L 353.18 970.22 L 354.07 970.9 L 355.49 970.96 L 356.99 970.22 L 357.46 971.79 L 359.51 972.63 L 360.49 972.17 L 360.92 972.16 L 360.94 972.87 L 361.67 973.37 L 362.66 974.24 L 365.83 977.17 L 366.49 978.93 L 367.38 979.43 L 368.09 979.41 L 368.2 980.28 L 368.04 981 L 369.1 981.15 L 368.94 982.04 L 368.53 983.19 L 369.08 983.89 L 369.88 983.87 L 370.42 984.13 L 370.42 984.83 L 371.07 985.35 L 372.27 987.87 L 372.65 988.57 L 373.63 988.72 L 376.32 990.25 L 376.78 990.5 L 377.82 989.87 L 377.75 1003.1 L 378.29 1003.08 L 378.22 1019.73 L 310.07 1020.5 L 275.82 1020.78 L 276.45 1003.85 L 275.48 1003.78 L 275.56 987.12 L 309.1 986.95 Z",
      "position": {
        "x": 335.4,
        "y": 993.3
      },
      "badgeAnchor": {
        "x": 334.92,
        "y": 993.69
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "rock",
      "name": "Rock",
      "regionId": "southwest",
      "adjacencies": [
        "murray",
        "nobles",
        "pipestone"
      ],
      "shape": "M 143.22 1070.08 L 142.75 1137.7 L 138.31 1137.69 L 86.23 1137.15 L 87.2 1069.7 L 141.45 1070.03 Z",
      "position": {
        "x": 114.9,
        "y": 1103.7
      },
      "badgeAnchor": {
        "x": 115.46,
        "y": 1101.43
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "nobles",
      "name": "Nobles",
      "regionId": "southwest",
      "adjacencies": [
        "cottonwood",
        "jackson",
        "murray",
        "rock"
      ],
      "shape": "M 143.22 1070.08 L 225.9 1070.77 L 227.24 1070.84 L 226.91 1137.9 L 194.02 1137.77 L 142.75 1137.7 Z",
      "position": {
        "x": 185,
        "y": 1104.1
      },
      "badgeAnchor": {
        "x": 193.57,
        "y": 1101.43
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "jackson",
      "name": "Jackson",
      "regionId": "southwest",
      "adjacencies": [
        "cottonwood",
        "martin",
        "nobles",
        "watonwan"
      ],
      "shape": "M 227.24 1070.84 L 268.17 1070.72 L 309.99 1070.72 L 310.87 1070.79 L 310.96 1137.58 L 307.67 1137.6 L 226.91 1137.9 Z",
      "position": {
        "x": 269,
        "y": 1104.3
      },
      "badgeAnchor": {
        "x": 263.16,
        "y": 1101.43
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "martin",
      "name": "Martin",
      "regionId": "southwest",
      "adjacencies": [
        "blue-earth",
        "faribault",
        "jackson",
        "watonwan"
      ],
      "shape": "M 378.71 1069.94 L 395.83 1069.75 L 396.7 1136.62 L 369.61 1137.09 L 310.96 1137.58 L 310.87 1070.79 Z",
      "position": {
        "x": 349.4,
        "y": 1103.8
      },
      "badgeAnchor": {
        "x": 344.4,
        "y": 1101.43
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "watonwan",
      "name": "Watonwan",
      "regionId": "southwest",
      "adjacencies": [
        "blue-earth",
        "brown",
        "cottonwood",
        "jackson",
        "martin"
      ],
      "shape": "M 310.07 1020.5 L 378.22 1019.73 L 378.71 1069.94 L 310.87 1070.79 L 309.99 1070.72 Z",
      "position": {
        "x": 344.3,
        "y": 1045.3
      },
      "badgeAnchor": {
        "x": 354.01,
        "y": 1044.46
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "anoka",
      "name": "Anoka",
      "regionId": "metro",
      "adjacencies": [
        "chisago",
        "hennepin",
        "isanti",
        "ramsey",
        "sherburne",
        "washington",
        "wright"
      ],
      "shape": "M 558.91 763.73 L 559.53 785.92 L 560.28 819.3 L 532.14 820.17 L 532.47 837.22 L 525.04 837.39 L 525.08 835.01 L 524.97 834.23 L 524.76 833.34 L 524.75 832.45 L 524.82 831.76 L 524.82 831.3 L 524.89 830.78 L 525.13 830.07 L 525.29 829.27 L 525.18 828.47 L 524.99 827.86 L 524.97 826.97 L 524.95 826.1 L 525.11 825.3 L 525.09 824.59 L 524.99 824.06 L 524.71 823.8 L 523.98 823.02 L 523.27 822.34 L 522.99 821.73 L 522.8 821.19 L 522.61 820.5 L 522.59 820.06 L 522.57 819.61 L 522.21 819 L 521.84 818.48 L 521.65 817.87 L 521.2 817.35 L 520.92 817.09 L 519.49 816.42 L 519.04 816.08 L 518.41 815.55 L 517.77 815.05 L 517.42 814.96 L 517.16 814.89 L 516.79 814.72 L 516.43 814.37 L 515.98 813.94 L 515.52 813.43 L 515.07 812.73 L 514.6 812.04 L 514.23 811.52 L 513.87 811.17 L 513.33 810.91 L 512.72 810.75 L 512.09 810.59 L 511.28 810.07 L 510.65 809.57 L 509.92 808.7 L 509.55 808.44 L 509.01 808.02 L 508.47 807.67 L 507.67 807.25 L 506.87 807.1 L 506.42 806.75 L 506.06 806.4 L 505.78 805.7 L 505.48 804.75 L 505.31 804.21 L 504.86 803.88 L 504.49 803.53 L 504.32 803.44 L 503.86 803.37 L 502.98 803.22 L 502.09 803.32 L 501.48 803.42 L 500.85 803.53 L 500.49 803.18 L 500.03 802.66 L 499.5 802.05 L 498.96 801.63 L 498.33 801.65 L 497.46 801.75 L 496.66 801.86 L 496.29 801.68 L 495.86 801.44 L 495.41 801.09 L 494.67 800.05 L 493.86 799.2 L 493.67 799.02 L 493.13 798.67 L 492.59 798.43 L 492.22 798 L 492.06 764.93 L 543.87 763.77 Z",
      "position": {
        "x": 532.4,
        "y": 791.3
      },
      "badgeAnchor": {
        "x": 516.95,
        "y": 790.2
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "hennepin",
      "name": "Hennepin",
      "regionId": "metro",
      "adjacencies": [
        "anoka",
        "carver",
        "dakota",
        "ramsey",
        "scott",
        "sherburne",
        "wright"
      ],
      "shape": "M 491.96 797.91 L 492.22 798 L 492.59 798.43 L 496.66 801.86 L 498.96 801.63 L 500.85 803.53 L 502.98 803.22 L 504.49 803.53 L 505.31 804.21 L 506.42 806.75 L 509.01 808.02 L 512.09 810.59 L 513.87 811.17 L 516.79 814.72 L 521.2 817.35 L 522.57 819.61 L 523.27 822.34 L 524.99 824.06 L 525.04 837.39 L 532.47 837.22 L 535.4 837.15 L 535.83 854.62 L 536.32 856.9 L 536.06 860.36 L 537.54 862.89 L 541.02 864.04 L 539.97 865.29 L 538.04 869.4 L 537.01 870.49 L 537.29 871.71 L 536.13 874.3 L 534.39 875.5 L 534.16 877 L 529.2 881.37 L 526.38 881.79 L 525.7 882.78 L 522.55 884.52 L 520.26 884.76 L 519.82 885.22 L 519.13 885.41 L 518.52 885.95 L 516.81 885.2 L 515.68 885.84 L 514.6 885.51 L 513.02 886.09 L 512.27 884.5 L 511.73 884 L 510.3 883.86 L 509.12 882.12 L 506.82 882.26 L 505.01 881.16 L 504.49 881.16 L 503.81 882.33 L 502.92 882.8 L 500.8 882.31 L 499.22 882.88 L 498.14 882.29 L 496.99 882.94 L 496.17 881.89 L 495.14 882.88 L 493.02 883.3 L 492.95 880.12 L 492.52 866.18 L 458.79 867.15 L 458.41 850.29 L 457.89 832.03 L 458.83 829.98 L 462.76 828.29 L 463.87 826.33 L 465.18 821.52 L 466.99 819.45 L 470.02 816.46 L 473.25 814.96 L 473.91 813.19 L 472.97 807.03 L 474.18 805.67 L 476.14 806.07 L 478.32 804.87 L 480.18 804.9 L 482.53 803.36 L 485 802.59 L 485.77 801.32 L 489.12 801.16 Z",
      "position": {
        "x": 494.8,
        "y": 836.1
      },
      "badgeAnchor": {
        "x": 499.52,
        "y": 842.92
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "ramsey",
      "name": "Ramsey",
      "regionId": "metro",
      "adjacencies": [
        "anoka",
        "dakota",
        "hennepin",
        "washington"
      ],
      "shape": "M 532.47 837.22 L 532.14 820.17 L 560.28 819.3 L 565.33 819.35 L 566.18 864.3 L 561.83 864.32 L 560.4 863.64 L 559.48 862.24 L 557.1 859.13 L 551.88 859.08 L 551.95 858.38 L 550.88 858.4 L 550.81 859.11 L 546.83 859.02 L 543.04 863.44 L 541.02 864.04 L 540.03 863.79 L 537.54 862.89 L 536.06 860.36 L 536.32 856.9 L 535.83 854.62 L 535.4 837.15 Z",
      "position": {
        "x": 550.4,
        "y": 834.9
      },
      "badgeAnchor": {
        "x": 551.62,
        "y": 842.44
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "washington",
      "name": "Washington",
      "regionId": "metro",
      "adjacencies": [
        "anoka",
        "chisago",
        "dakota",
        "ramsey"
      ],
      "shape": "M 559.53 785.92 L 590.84 785.2 L 597.05 785.14 L 596.51 785.43 L 596.03 785.71 L 595.12 786.34 L 595.09 788.46 L 596.22 791.09 L 595.5 794.11 L 596.44 800.01 L 595.03 803.67 L 595.26 806.8 L 595.75 807.44 L 597.3 809.62 L 597.35 815.01 L 598.53 819.75 L 597.89 821.63 L 596.23 823.18 L 595.8 823.72 L 591.05 828.24 L 590.72 829.15 L 590.67 831.15 L 591.15 832.4 L 595.07 835.88 L 595.97 837.39 L 595.52 844.3 L 596.3 848.1 L 597.07 849.47 L 598.06 851.7 L 598.15 857.21 L 597.75 859.77 L 596.39 861.11 L 595.33 862.24 L 595.78 863.71 L 597.1 866.51 L 597.19 868.2 L 596.55 870.48 L 596.74 871.64 L 597.02 875.23 L 595.21 879.42 L 595.1 880.17 L 594.55 883.35 L 592.09 887.48 L 592.01 891.36 L 593.42 892.65 L 594.27 893.25 L 591.78 892.52 L 589.36 891.43 L 587.13 891.58 L 584.3 890.94 L 582.26 887.9 L 579.39 886.38 L 574.41 885.98 L 572.45 888.5 L 570.76 888.54 L 569.4 887.34 L 566.82 887.15 L 564.98 887.63 L 563.2 887.32 L 561.22 882.78 L 562.27 874.9 L 561.83 867.85 L 560.4 863.64 L 561.29 863.97 L 561.83 864.32 L 566.18 864.3 L 565.33 819.35 L 560.28 819.3 Z",
      "position": {
        "x": 580.47,
        "y": 856.96
      },
      "badgeAnchor": {
        "x": 580.47,
        "y": 856.96
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "carver",
      "name": "Carver",
      "regionId": "metro",
      "adjacencies": [
        "hennepin",
        "mcleod",
        "scott",
        "sibley",
        "wright"
      ],
      "shape": "M 425.12 850.81 L 458.41 850.29 L 458.79 867.15 L 492.52 866.18 L 493.02 883.3 L 492.67 883.39 L 490.99 883.44 L 490.29 884.33 L 488.08 884.21 L 487.56 884.75 L 485.71 885.15 L 485.1 885.77 L 484.7 887.74 L 482.67 887.69 L 482.34 888.49 L 482.89 889.55 L 480 891.2 L 479.76 891.83 L 481.29 893.2 L 480.6 894 L 479.34 893.32 L 479.29 894.84 L 478.25 895.92 L 478.06 898.65 L 479.03 899.07 L 479.33 899.78 L 478.98 900.49 L 479.73 901.71 L 478.54 904.11 L 477.22 904.86 L 476.16 904.53 L 475.46 905.42 L 473.06 904.78 L 472.19 905.33 L 469.46 909.98 L 467.34 910.29 L 466.55 910.94 L 467.02 911.98 L 466.76 912.61 L 465.27 912.81 L 463.98 914.35 L 461.7 915.2 L 461.26 915.55 L 461.72 916.33 L 461.45 916.7 L 460.93 916.71 L 459.84 915.49 L 459.68 909.06 L 443.11 909.26 L 442.75 900.98 L 426.18 901.19 L 425.85 867.2 L 425.14 867.13 Z",
      "position": {
        "x": 459,
        "y": 888
      },
      "badgeAnchor": {
        "x": 458.01,
        "y": 883.14
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "scott",
      "name": "Scott",
      "regionId": "metro",
      "adjacencies": [
        "carver",
        "dakota",
        "hennepin",
        "le-sueur",
        "rice",
        "sibley"
      ],
      "shape": "M 493.02 883.3 L 494.08 883.01 L 495.14 882.88 L 496.17 881.89 L 496.99 882.94 L 498.14 882.29 L 499.22 882.88 L 500.8 882.31 L 502.92 882.8 L 503.81 882.33 L 504.49 881.16 L 505.01 881.16 L 506.82 882.26 L 509.12 882.12 L 510.3 883.86 L 511.73 884 L 512.27 884.5 L 513.02 886.09 L 514.6 885.51 L 515.68 885.84 L 516.81 885.2 L 518.52 885.95 L 519.82 885.22 L 520.52 899.4 L 521.32 899.38 L 521.89 915.7 L 527.55 915.65 L 527.77 932.41 L 493.75 933.14 L 440.78 934.65 L 440.4 933.77 L 440.92 933.05 L 442.62 933.91 L 442.5 932.41 L 441.86 931.54 L 442.54 930.2 L 441.98 928.88 L 442.49 928.25 L 442.75 927.62 L 442.45 926.41 L 442 925.8 L 443.11 924.63 L 443.83 924.53 L 444.07 923.64 L 444.87 923.62 L 444.84 922.39 L 445.72 922.63 L 446.52 922.61 L 447.72 920.54 L 447.79 919.57 L 448.58 919.55 L 449.39 919.9 L 449.73 919.27 L 454.02 917.13 L 455.07 916.57 L 455.97 917.01 L 456.42 917.6 L 457.49 917.15 L 458.27 916.59 L 458.7 916.14 L 459.8 917.53 L 460.13 916.56 L 459.84 915.49 L 460.46 915.76 L 460.93 916.71 L 461.45 916.7 L 461.72 916.33 L 461.26 915.55 L 461.7 915.2 L 463.98 914.35 L 465.27 912.81 L 466.76 912.61 L 467.02 911.98 L 466.55 910.94 L 467.34 910.29 L 469.46 909.98 L 472.19 905.33 L 474.04 904.76 L 475.46 905.42 L 476.16 904.53 L 477.22 904.86 L 478.54 904.11 L 479.73 901.71 L 478.98 900.49 L 479.33 899.78 L 479.03 899.07 L 478.06 898.65 L 478.25 895.92 L 479.29 894.84 L 479.34 893.32 L 480.6 894 L 481.29 893.2 L 479.76 891.83 L 480 891.2 L 482.89 889.55 L 482.34 888.49 L 482.67 887.69 L 484.7 887.74 L 485.1 885.77 L 485.71 885.15 L 487.56 884.75 L 488.08 884.21 L 489.68 884.52 L 490.99 883.44 Z",
      "position": {
        "x": 499.7,
        "y": 910.9
      },
      "badgeAnchor": {
        "x": 499.1,
        "y": 910.41
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "dakota",
      "name": "Dakota",
      "regionId": "metro",
      "adjacencies": [
        "goodhue",
        "hennepin",
        "ramsey",
        "rice",
        "scott",
        "washington"
      ],
      "shape": "M 541.02 864.04 L 541.89 863.91 L 543.04 863.44 L 546.83 859.02 L 550.81 859.11 L 550.88 858.4 L 551.95 858.38 L 551.88 859.08 L 557.1 859.13 L 560.4 863.64 L 561.34 866.09 L 561.83 867.85 L 562.27 874.9 L 561.22 882.78 L 563.2 887.32 L 564.98 887.63 L 566.82 887.15 L 569.4 887.34 L 570.76 888.54 L 572.45 888.5 L 574.41 885.98 L 579.39 886.38 L 582.26 887.9 L 584.3 890.94 L 587.13 891.58 L 589.36 891.43 L 594.27 893.25 L 595.69 893.97 L 602.15 897.33 L 602.05 913.35 L 594.18 914.09 L 595.29 930.55 L 578.01 931.17 L 577.94 935.58 L 576.05 937.39 L 574.79 937.07 L 574.27 937.44 L 573.66 937.98 L 571.68 936.62 L 570.1 937 L 567.85 936.01 L 564.95 936.88 L 562.8 936.48 L 562.47 937.47 L 561.86 937.47 L 561.24 937.06 L 561.26 945.62 L 527.77 946.52 L 527.77 932.41 L 527.55 915.65 L 521.89 915.7 L 521.32 899.38 L 520.52 899.4 L 519.82 885.22 L 520.26 884.76 L 522.55 884.52 L 525.7 882.78 L 526.38 881.79 L 529.2 881.37 L 534.16 877 L 534.39 875.5 L 535.6 875.02 L 537.29 871.71 L 537.01 870.49 Z",
      "position": {
        "x": 553.8,
        "y": 911.9
      },
      "badgeAnchor": {
        "x": 554.55,
        "y": 912.09
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "wright",
      "name": "Wright",
      "regionId": "metro",
      "adjacencies": [
        "anoka",
        "carver",
        "hennepin",
        "mcleod",
        "meeker",
        "sherburne",
        "stearns"
      ],
      "shape": "M 389.98 792.41 L 389.98 789.83 L 390.91 789.35 L 390.47 788.25 L 391.43 787.69 L 395 787.12 L 396.86 786.01 L 399.43 785.5 L 400.74 786.25 L 401.19 787.03 L 401.43 787.45 L 401.87 788.96 L 403.64 788.96 L 406.85 785.99 L 410.78 780.98 L 412.1 780.33 L 412.8 779.6 L 412.92 777.65 L 414.1 775.42 L 413.91 774.28 L 414.21 772.33 L 417.51 765.89 L 418.89 764.27 L 418.99 764.53 L 420.65 767.05 L 422.18 768.69 L 423.34 769.02 L 424.49 769.18 L 424.58 769.35 L 425.99 769.14 L 427.43 769.82 L 427.89 770.69 L 428.34 771.13 L 428.88 771.46 L 430.15 772.76 L 431.05 773.61 L 432.1 772.8 L 432.44 772.43 L 433.85 772.31 L 434.72 772.12 L 435.09 771.93 L 436.33 772.43 L 436.86 772.78 L 437.33 774 L 438.26 775.04 L 439.68 775.89 L 440.43 777.46 L 440.88 778.35 L 441.62 779.31 L 444.57 780.82 L 447.67 781.1 L 448.39 781.25 L 448.85 782.14 L 452.02 785.5 L 457.94 788.63 L 459.37 788.7 L 460.58 788.13 L 461.72 787.66 L 462.43 787.66 L 462.97 787.73 L 463.68 788.15 L 464.31 788.58 L 465.89 788.27 L 466.43 788.18 L 467.21 787.97 L 467.56 787.45 L 468.52 786.98 L 469.42 788.02 L 469.79 788.35 L 471.65 788.58 L 474.66 788.42 L 475.29 788.75 L 476.87 788.72 L 482.55 789.12 L 483.96 789 L 484.2 788.02 L 484.91 787.92 L 486.2 790.27 L 486.72 793.52 L 488.55 795.96 L 489.89 796.27 L 490.32 796.36 L 490.53 797.32 L 490.9 797.58 L 491.16 797.75 L 491.96 797.91 L 491.46 798.71 L 490.85 799.35 L 489.65 800.71 L 489.12 801.16 L 487.89 801.27 L 486.81 801.13 L 485.77 801.32 L 485 802.59 L 484.22 803.04 L 483.42 803.32 L 482.53 803.36 L 481.05 804.45 L 480.18 804.9 L 479.29 804.92 L 478.32 804.87 L 477.1 805.34 L 476.58 805.7 L 476.14 806.07 L 475.69 805.98 L 475.34 805.72 L 474.18 805.67 L 472.97 807.03 L 473.08 807.81 L 473.2 809.05 L 473.67 810.28 L 473.91 813.19 L 473.58 814.34 L 473.25 814.96 L 472.99 815.24 L 471.06 815.73 L 470.02 816.46 L 469.23 817.19 L 468.19 818.27 L 466.99 819.45 L 465.18 821.52 L 464.59 822.78 L 464.27 824.81 L 463.87 826.33 L 463 827.49 L 462.76 828.29 L 461.98 828.83 L 460.13 829.68 L 458.83 829.98 L 458.41 831.3 L 457.89 832.03 L 458.41 850.29 L 425.12 850.81 L 391.74 851.04 L 391.11 803.51 L 390.33 803.53 Z",
      "position": {
        "x": 426.9,
        "y": 815.5
      },
      "badgeAnchor": {
        "x": 426.63,
        "y": 814.43
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "meeker",
      "name": "Meeker",
      "regionId": "south-central",
      "adjacencies": [
        "kandiyohi",
        "mcleod",
        "renville",
        "stearns",
        "wright"
      ],
      "shape": "M 321.7 784.89 L 373.43 784.39 L 373.54 792.77 L 389.98 792.41 L 390.02 793.56 L 390.33 803.53 L 391.11 803.51 L 391.74 851.04 L 358.12 851.87 L 358.38 868.28 L 322.79 868.87 L 322.32 802.03 L 321.71 801.95 Z",
      "position": {
        "x": 354.9,
        "y": 819.6
      },
      "badgeAnchor": {
        "x": 355.63,
        "y": 820.03
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "mcleod",
      "name": "McLeod",
      "regionId": "south-central",
      "adjacencies": [
        "carver",
        "meeker",
        "renville",
        "sibley",
        "wright"
      ],
      "shape": "M 391.74 851.04 L 425.12 850.81 L 425.14 867.13 L 425.85 867.2 L 426.18 901.19 L 392.79 901.76 L 392.91 918.8 L 359.6 919.36 L 359.3 902.08 L 359.01 868.35 L 358.38 868.28 L 358.12 851.87 Z",
      "position": {
        "x": 385,
        "y": 877.1
      },
      "badgeAnchor": {
        "x": 384.71,
        "y": 883.14
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "sibley",
      "name": "Sibley",
      "regionId": "south-central",
      "adjacencies": [
        "carver",
        "le-sueur",
        "mcleod",
        "nicollet",
        "renville",
        "scott"
      ],
      "shape": "M 426.18 901.19 L 442.75 900.98 L 443.11 909.26 L 459.68 909.06 L 459.84 915.49 L 460.13 916.56 L 459.8 917.53 L 459.35 917.27 L 458.7 916.14 L 458.27 916.59 L 457.49 917.15 L 457.14 917.41 L 456.42 917.6 L 455.97 917.01 L 455.52 916.66 L 452.54 917.97 L 449.73 919.27 L 449.39 919.9 L 448.58 919.55 L 447.79 919.57 L 447.13 921.62 L 446.52 922.61 L 445.72 922.63 L 444.84 922.39 L 444.87 923.62 L 444.07 923.64 L 443.83 924.53 L 443.11 924.63 L 442 925.8 L 442.75 927.62 L 442.49 928.25 L 441.98 928.88 L 442.52 929.49 L 442.02 930.74 L 441.86 931.54 L 442.5 932.41 L 442.87 933.28 L 442.62 933.91 L 440.92 933.05 L 440.4 933.77 L 440.78 934.65 L 440.45 935.54 L 441.79 936.03 L 441.81 937.09 L 443.25 938.38 L 443.63 939.44 L 443.34 942.09 L 442.56 942.62 L 443.01 942.89 L 443.11 943.95 L 441.89 944.94 L 440.55 948.23 L 438.71 948.8 L 438.54 949.34 L 440.07 949.74 L 439.98 950.46 L 438.24 951.29 L 342.6 953.07 L 341.05 902.29 L 359.3 902.08 L 359.6 919.36 L 392.91 918.8 L 392.79 901.76 Z",
      "position": {
        "x": 416.6,
        "y": 926.5
      },
      "badgeAnchor": {
        "x": 417.34,
        "y": 926.21
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "le-sueur",
      "name": "Le Sueur",
      "regionId": "south-central",
      "adjacencies": [
        "blue-earth",
        "nicollet",
        "rice",
        "scott",
        "sibley",
        "waseca"
      ],
      "shape": "M 440.78 934.65 L 493.75 933.14 L 495.44 1000.47 L 461.65 1001.44 L 461.28 992.73 L 427.57 993.6 L 426.95 993.35 L 426.48 992.12 L 426.61 990.1 L 428.27 988.81 L 427.97 987.59 L 429.02 986.43 L 429.9 986.3 L 429.85 984.55 L 430.53 982.95 L 433.16 981.38 L 434.71 979.24 L 436.97 973.9 L 437.77 973.62 L 438.1 972.82 L 438 971.93 L 435.47 970.49 L 434.86 966.8 L 434.22 965.49 L 435.37 965.37 L 435.52 964.85 L 433.91 963.99 L 435.66 963.25 L 435.25 960.44 L 436.64 959.44 L 437.93 957.03 L 438.24 951.29 L 438.85 950.84 L 439.98 950.46 L 440.07 949.74 L 438.54 949.34 L 438.71 948.8 L 440.55 948.23 L 441.89 944.94 L 443.11 943.95 L 443.01 942.89 L 442.56 942.62 L 443.34 942.09 L 443.5 940.76 L 443.25 938.38 L 442.17 937.7 L 441.79 936.03 L 440.45 935.54 Z",
      "position": {
        "x": 465.7,
        "y": 964.4
      },
      "badgeAnchor": {
        "x": 466.35,
        "y": 967.92
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "nicollet",
      "name": "Nicollet",
      "regionId": "south-central",
      "adjacencies": [
        "blue-earth",
        "brown",
        "le-sueur",
        "renville",
        "sibley"
      ],
      "shape": "M 342.6 953.07 L 438.24 951.29 L 438.43 952.16 L 437.93 957.03 L 436.64 959.44 L 435.25 960.44 L 435.66 963.25 L 433.91 963.99 L 435.52 964.85 L 435.37 965.37 L 434.22 965.49 L 434.86 966.8 L 435.47 970.49 L 438 971.93 L 438.1 972.82 L 437.77 973.62 L 436.97 973.9 L 434.71 979.24 L 433.16 981.38 L 430.53 982.95 L 429.85 984.55 L 429.9 986.3 L 428.32 987.05 L 427.97 987.59 L 428.27 988.81 L 426.61 990.1 L 426.6 992.92 L 427.57 993.6 L 427.15 994.74 L 427.83 997.2 L 427.59 998 L 426.34 997.69 L 426.18 998.64 L 426.39 999.53 L 427.55 1000.03 L 427.92 1000.73 L 427.61 1002.4 L 429.28 1005.64 L 429.29 1006.68 L 428.44 1007.94 L 425 1008.46 L 422.8 1010.09 L 421.81 1009.41 L 418.98 1009.22 L 415.91 1007.08 L 415.11 1007.1 L 414.56 1006.14 L 412.95 1005.74 L 412.21 1004.61 L 409.87 1003.34 L 409.26 1003.62 L 404.1 1002.33 L 401.33 1001.51 L 400.86 1000.82 L 399.08 1000.94 L 399.33 999.79 L 398.96 999.1 L 397.83 999.91 L 396.04 999.6 L 393.6 997.53 L 392.89 997.46 L 392.25 996.24 L 391.11 997.06 L 389.03 994.99 L 387.96 995.11 L 387.95 994.4 L 386.59 993.37 L 385.35 994.01 L 384.8 992.88 L 384.01 992.99 L 383.46 991.94 L 382.12 991.98 L 380.85 990.86 L 379.89 991.49 L 379.18 991.33 L 379.16 990.72 L 377.82 989.87 L 377.3 990.05 L 376.78 990.5 L 376.32 990.25 L 375.42 989.65 L 372.65 988.57 L 371.82 987 L 370.42 984.83 L 370.42 984.13 L 369.88 983.87 L 369.08 983.89 L 368.51 982.49 L 369.1 981.15 L 368.04 981 L 368.2 980.28 L 368.09 979.41 L 367.38 979.43 L 366.49 978.93 L 366.47 978.04 L 361.67 973.37 L 360.94 972.87 L 360.92 972.16 L 359.51 972.63 L 357.46 971.79 L 357.44 970.83 L 356.99 970.22 L 355.49 970.96 L 354.07 970.9 L 352.43 969.09 L 350.57 969.13 L 347.9 968.66 L 346.91 968.33 L 346.46 967.18 L 343.97 967.34 L 342.48 967.54 L 342.35 966.4 L 341.73 965.79 L 340.56 965.11 L 339.33 965.67 L 338.42 964.71 L 337.53 964.92 L 336.38 965.37 L 335.76 964.86 L 336.09 964.06 L 335.55 962.93 L 334.66 962.95 L 333.77 963.14 L 333.76 962.34 L 333.83 961.56 L 332.76 961.66 L 331.79 961.33 L 331.77 960.62 L 332.54 959.73 L 332.52 958.84 L 330.21 958.01 L 328.5 957.52 L 326.88 956.32 L 325.53 955.21 L 324.03 955.24 L 322.97 955.87 L 318.84 953.14 Z",
      "position": {
        "x": 406.4,
        "y": 976.2
      },
      "badgeAnchor": {
        "x": 406.66,
        "y": 976.1
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "blue-earth",
      "name": "Blue Earth",
      "regionId": "south-central",
      "adjacencies": [
        "brown",
        "faribault",
        "le-sueur",
        "martin",
        "nicollet",
        "waseca",
        "watonwan"
      ],
      "shape": "M 427.57 993.6 L 461.28 992.73 L 461.65 1001.44 L 462.36 1043.64 L 463.02 1068.56 L 395.83 1069.75 L 378.71 1069.94 L 378.22 1019.73 L 378.29 1003.08 L 377.75 1003.1 L 377.82 989.87 L 378.53 990.2 L 379.18 991.33 L 379.89 991.49 L 380.85 990.86 L 382.12 991.98 L 383.46 991.94 L 384.01 992.99 L 384.8 992.88 L 385.35 994.01 L 386.59 993.37 L 387.95 994.4 L 387.96 995.11 L 389.03 994.99 L 391.11 997.06 L 392.25 996.24 L 392.89 997.46 L 393.6 997.53 L 396.04 999.6 L 397.83 999.91 L 398.96 999.1 L 399.33 999.79 L 399.08 1000.94 L 400.86 1000.82 L 401.33 1001.51 L 404.1 1002.33 L 409.26 1003.62 L 409.87 1003.34 L 412.21 1004.61 L 412.95 1005.74 L 414.56 1006.14 L 415.11 1007.1 L 415.91 1007.08 L 418.98 1009.22 L 421.81 1009.41 L 422.8 1010.09 L 425 1008.46 L 428.44 1007.94 L 429.29 1006.68 L 429.28 1005.64 L 427.61 1002.4 L 427.92 1000.73 L 427.55 1000.03 L 426.39 999.53 L 426.18 998.64 L 426.34 997.69 L 427.59 998 L 427.83 997.2 L 427.17 995.37 Z",
      "position": {
        "x": 409.4,
        "y": 1038.6
      },
      "badgeAnchor": {
        "x": 411.06,
        "y": 1038.66
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "waseca",
      "name": "Waseca",
      "regionId": "south-central",
      "adjacencies": [
        "blue-earth",
        "faribault",
        "freeborn",
        "le-sueur",
        "rice",
        "steele"
      ],
      "shape": "M 495.44 1000.47 L 512.2 1000.16 L 513.71 1067.45 L 479.8 1068.08 L 463.02 1068.56 L 462.36 1043.64 L 461.65 1001.44 Z",
      "position": {
        "x": 487.5,
        "y": 1029.2
      },
      "badgeAnchor": {
        "x": 486.04,
        "y": 1036.6
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "steele",
      "name": "Steele",
      "regionId": "south-central",
      "adjacencies": [
        "dodge",
        "freeborn",
        "mower",
        "rice",
        "waseca"
      ],
      "shape": "M 512.2 1000.16 L 562.02 998.68 L 564.01 1065.69 L 563.4 1065.71 L 513.71 1067.45 Z",
      "position": {
        "x": 537.9,
        "y": 1029.2
      },
      "badgeAnchor": {
        "x": 539.19,
        "y": 1037.52
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "rice",
      "name": "Rice",
      "regionId": "south-central",
      "adjacencies": [
        "dakota",
        "dodge",
        "goodhue",
        "le-sueur",
        "scott",
        "steele",
        "waseca"
      ],
      "shape": "M 493.75 933.14 L 527.77 932.41 L 527.77 946.52 L 561.26 945.62 L 562.82 998.66 L 562.02 998.68 L 512.2 1000.16 L 495.44 1000.47 Z",
      "position": {
        "x": 521.8,
        "y": 972.7
      },
      "badgeAnchor": {
        "x": 520.73,
        "y": 967.92
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "goodhue",
      "name": "Goodhue",
      "regionId": "southeast",
      "adjacencies": [
        "dakota",
        "dodge",
        "olmsted",
        "rice",
        "wabasha"
      ],
      "shape": "M 602.36 897.45 L 608.33 902.77 L 611.65 906.69 L 617.67 911.37 L 618.79 913.28 L 618.49 915.15 L 618.87 916.28 L 619.99 916.77 L 622.37 917.69 L 623.09 918.02 L 625.75 918.58 L 627.59 920.82 L 627.96 921.34 L 628.64 922.79 L 629.23 924.87 L 631.84 923.99 L 632.62 923.81 L 634.69 925.08 L 642.89 924.74 L 646.21 925.1 L 648.3 925.88 L 649.22 926.25 L 653.96 925.95 L 657.91 927.26 L 661.13 929.07 L 662.69 931.17 L 664.56 938.38 L 665.81 940.24 L 669.38 942.57 L 671.72 945.1 L 645.87 946.02 L 646.21 962.78 L 629.63 963.37 L 630.83 996.68 L 612.92 997.32 L 562.82 998.66 L 561.26 945.62 L 561.24 937.06 L 561.86 937.47 L 562.47 937.47 L 562.8 936.48 L 564.34 937.07 L 565.83 936.41 L 567.85 936.01 L 570.1 937 L 571.68 936.62 L 572.41 937.3 L 573.66 937.98 L 574.27 937.44 L 574.79 937.07 L 576.05 937.39 L 577.94 935.58 L 578.01 931.17 L 595.29 930.55 L 594.18 914.09 L 602.05 913.35 Z",
      "position": {
        "x": 596.2,
        "y": 964.1
      },
      "badgeAnchor": {
        "x": 597.49,
        "y": 965.41
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "wabasha",
      "name": "Wabasha",
      "regionId": "southeast",
      "adjacencies": [
        "goodhue",
        "olmsted",
        "winona"
      ],
      "shape": "M 671.72 945.1 L 672.4 945.79 L 675.05 947.92 L 677.17 948.96 L 678.42 949.12 L 680.93 949.41 L 688.55 951.76 L 693.84 952.81 L 694.92 953.55 L 695.83 953.9 L 698.35 954.72 L 700.44 956.58 L 701.24 957.17 L 706.72 959.84 L 707.43 960.18 L 710.5 960.95 L 711.84 961.94 L 713.94 965.21 L 716.66 967.08 L 718.35 970.47 L 718.01 972.03 L 717.67 972.49 L 717.27 972.97 L 717.11 974.37 L 717.16 974.99 L 718.31 976.14 L 721.03 977.9 L 721.11 979.48 L 721.91 980.87 L 722.97 982.51 L 722.24 985.05 L 722.5 987.04 L 725.32 991.72 L 725.85 992.29 L 727.31 993.4 L 696.35 994.61 L 697.06 1011.26 L 663.98 1012.3 L 663.2 995.84 L 630.83 996.68 L 629.63 963.37 L 646.21 962.78 L 645.87 946.02 Z",
      "position": {
        "x": 679.1,
        "y": 975.7
      },
      "badgeAnchor": {
        "x": 680,
        "y": 975.55
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "olmsted",
      "name": "Olmsted",
      "regionId": "southeast",
      "adjacencies": [
        "dodge",
        "fillmore",
        "goodhue",
        "mower",
        "wabasha",
        "winona"
      ],
      "shape": "M 612.92 997.32 L 630.83 996.68 L 663.2 995.84 L 663.98 1012.3 L 697.06 1011.26 L 699.06 1061.08 L 647.43 1063.15 L 647.41 1065.97 L 614.04 1067 L 613.97 1064.18 L 615.57 1064.06 Z",
      "position": {
        "x": 647.79,
        "y": 1031.38
      },
      "badgeAnchor": {
        "x": 650.5,
        "y": 1034.14
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "dodge",
      "name": "Dodge",
      "regionId": "southeast",
      "adjacencies": [
        "goodhue",
        "mower",
        "olmsted",
        "rice",
        "steele"
      ],
      "shape": "M 562.02 998.68 L 562.82 998.66 L 612.92 997.32 L 615.57 1064.06 L 613.97 1064.18 L 564.01 1065.69 Z",
      "position": {
        "x": 588.6,
        "y": 1029.8
      },
      "badgeAnchor": {
        "x": 587.96,
        "y": 1026.88
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "faribault",
      "name": "Faribault",
      "regionId": "south-central",
      "adjacencies": [
        "blue-earth",
        "freeborn",
        "martin",
        "waseca"
      ],
      "shape": "M 463.02 1068.56 L 479.8 1068.08 L 481.17 1134.99 L 476.99 1135.06 L 396.7 1136.62 L 395.83 1069.75 Z",
      "position": {
        "x": 434.8,
        "y": 1102.5
      },
      "badgeAnchor": {
        "x": 429.17,
        "y": 1101.43
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "freeborn",
      "name": "Freeborn",
      "regionId": "south-central",
      "adjacencies": [
        "faribault",
        "mower",
        "steele",
        "waseca"
      ],
      "shape": "M 513.71 1067.45 L 563.4 1065.71 L 565.38 1133.04 L 532.42 1134.01 L 481.17 1134.99 L 479.8 1068.08 Z",
      "position": {
        "x": 529.4,
        "y": 1100.5
      },
      "badgeAnchor": {
        "x": 515.9,
        "y": 1101.43
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "mower",
      "name": "Mower",
      "regionId": "southeast",
      "adjacencies": [
        "dodge",
        "fillmore",
        "freeborn",
        "olmsted",
        "steele"
      ],
      "shape": "M 563.4 1065.71 L 564.01 1065.69 L 613.97 1064.18 L 614.04 1067 L 647.41 1065.97 L 649.75 1130.41 L 645.03 1130.59 L 565.38 1133.04 Z",
      "position": {
        "x": 599.2,
        "y": 1098.3
      },
      "badgeAnchor": {
        "x": 599.83,
        "y": 1101.43
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "fillmore",
      "name": "Fillmore",
      "regionId": "southeast",
      "adjacencies": [
        "houston",
        "mower",
        "olmsted",
        "winona"
      ],
      "shape": "M 699.06 1061.08 L 748.03 1059.06 L 751.04 1126.29 L 701.87 1128.46 L 649.75 1130.41 L 647.41 1065.97 L 647.43 1063.15 Z",
      "position": {
        "x": 698.5,
        "y": 1094.9
      },
      "badgeAnchor": {
        "x": 684.65,
        "y": 1101.43
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "winona",
      "name": "Winona",
      "regionId": "southeast",
      "adjacencies": [
        "fillmore",
        "houston",
        "olmsted",
        "wabasha"
      ],
      "shape": "M 727.31 993.4 L 727.79 993.63 L 728.98 994.4 L 731.41 997.23 L 733.99 999.63 L 735.3 1000.44 L 742.4 1003.95 L 746.26 1004.8 L 747.65 1006.3 L 748.71 1009.57 L 749.76 1010.35 L 754.35 1012.79 L 756.77 1015.63 L 760.08 1018.12 L 760.79 1018.45 L 762.51 1019.26 L 764.88 1021.93 L 765.33 1022.27 L 765.71 1022.57 L 766.32 1022.87 L 768.72 1023.72 L 776.14 1024.17 L 779.18 1025.74 L 780.18 1026.17 L 781.32 1026.35 L 782.32 1026.56 L 783.78 1026.64 L 787.45 1028.24 L 790.86 1032.51 L 791.54 1033.26 L 796.12 1037.48 L 796.59 1037.76 L 797.94 1039.43 L 799.63 1043.17 L 804.85 1048.5 L 806.61 1052.26 L 806.89 1052.69 L 809.85 1055.91 L 748.03 1059.06 L 699.06 1061.08 L 697.06 1011.26 L 696.35 994.61 Z",
      "position": {
        "x": 727.4,
        "y": 1030.3
      },
      "badgeAnchor": {
        "x": 726.5,
        "y": 1026.88
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "houston",
      "name": "Houston",
      "regionId": "southeast",
      "adjacencies": [
        "fillmore",
        "winona"
      ],
      "shape": "M 748.03 1059.06 L 807.71 1056.09 L 810.04 1056.07 L 811.52 1058.63 L 813.76 1066.13 L 814.32 1067.17 L 815.9 1068.83 L 816.49 1070.25 L 815.57 1078.21 L 814.18 1081.81 L 813.71 1092.28 L 814.58 1093.33 L 815.36 1094.46 L 814.77 1097.03 L 815.03 1099.75 L 816.93 1102.83 L 819.9 1105.79 L 820.37 1107.01 L 820.25 1109.56 L 819.26 1113.17 L 819.59 1115.34 L 821.05 1117.95 L 821.58 1118.39 L 823.04 1120.14 L 822.85 1122.79 L 751.04 1126.29 Z",
      "position": {
        "x": 781.5,
        "y": 1090.6
      },
      "badgeAnchor": {
        "x": 781.32,
        "y": 1090.31
      },
      "ownerId": "",
      "armies": 0
    }
  ],
  "geometryVersion": "v1-5c5797d4-905ffda2",
  "seaRoutes": []
}
